/* eslint-disable max-lines */
const nClicks = {
  menu: {
    X: 'menu.x', // 삼선메뉴 닫기
    PROFILE: 'menu.profile', // 삼선메뉴 프로필편집
    FOLLOWLIST: 'menu.followlist', // 삼선메뉴 팔로우관리
    ALERT: 'menu.alert', // 삼선메뉴 알림설정
    BLOG: 'menu.blog', // 삼선메뉴 공지사항
    TALK: 'menu.talk', // 삼선메뉴 톡톡친구맺기
    LOGOUT: 'menu.logout', // 삼선메뉴 로그아웃
    SMARTBOT: 'menu.smartbot', // 삼선메뉴 고객센터스마트봇
    CS: 'menu.cs', // 삼선메뉴 고객센터
    CS2: 'menu.cs2', // 삼선메뉴 신고센터
    POLICY: 'menu.policy', // 삼선메뉴 이용정책
    PRIVACY: 'menu.privacy', // 삼선메뉴 개인정보처리방침
    BOOKING: 'menu.booking', // 삼선메뉴 예약/주문
    REACT_FEED: 'menu.reactfeed', // 삼선메뉴 반응남긴 리뷰
    RESERVATION: 'menu.reservation', // 삼선메뉴 예약
    ORDER: 'menu.order', // 삼선메뉴 주문
    MISSION: 'menu.mission', // 삼선메뉴 미션
    COUPON: 'menu.coupon', // 삼선메뉴 쿠폰
    QUEUE: 'menu.queue', // 삼선메뉴 줄서기
    BOOKINGALERT: 'menu.bookingalert', // 삼선메뉴 예약/주문 알림설정
    BOOKINGBLOG: 'menu.bookingblog', // 삼선메뉴 예약/주문 블로그
    BOOKINGDIRECTPAY: 'menu.bookingdirectpay', // 삼선메뉴 예약/주문 자동결제
    BOOKINGTALK: 'menu.bookingtalk', // 삼선메뉴 예약/주문 자동결제
    BOOKINGANNOUNCE: 'menu.bookingannounce', // 삼선메뉴 예약/주문 공지사항
  },
  profile: {
    BACK: 'profile.back', //프로필설정 뒤로가기
    IMAGE: 'profile.image', //프로필설정 프로필사진
    NICKNAME: 'profile.nickname', //프로필설정 닉네임
    INTRO: 'profile.intro', //프로필설정 소개
    SUBMIT: 'profile.submit', //프로필설정 저장하기
    TIP: 'profile.tip', //프로필설정 툴팁
  },
  addReview: {
    BACK: 'addreview.back', // 뒤로가기
    ALL: 'addreview.all', // 리스트뷰로 보기
    PHOTO: 'addreview.photo', // 사진뷰로 보기
    NEW: 'addreview.new', // 최신순
    VIEW: 'addreview.view', // 조회수순
    RATINGLOW: 'addreview.ratinglow', // 평점낮은순
    RATINGHIGH: 'addreview.ratinghigh', // 평점높은순
    ALIGN: 'addreview.align', // 정렬
    ALIGNOUT: 'addreview.alignout', // 정렬 나가기
    VIEWINFO: 'addreview.viewinfo', // 조회수안내
    LISTSELECT: 'addreview.listselect', // 리스트뷰에서 선택
    LISTSELECTX: 'addreview.listselectx', // 리스트뷰에서 선택해제
    PHOTOSELECT: 'addreview.photoselect', // 사진뷰에서 선택
    PHOTOSELECTX: 'addreview.photoselectx', // 사진뷰에서 선택해제
    COMPLETE: 'addreview.complete', // 리뷰 추가 완료
    OUT: 'addreview.out', // 팝업_추가안하고나가기
    CANCEL: 'addreview.cancel', // 팝업_팝업취소
  },
  applyFail: {
    NIDGO: 'applyfail.nidgo', // 참여신청페이지 실명인증 미충족 실명인증하러가기 클릭
    NIDOUT: 'applyfail.nidout', // 참여신청페이지 실명인증 미충족 닫기 클릭
    PAYGO: 'applyfail.paygo', // 참여신청페이지 페이회원 미충족 네이버페이가입하러가기 클릭
    PAYOUT: 'applyfail.payout', // 참여신청페이지 페이회원 미충족 닫기 클릭
  },
  apply: {
    ALLOK: 'apply.allok', // 참여신청페이지 전체동의 선택
    ALLNO: 'apply.allno', // 참여신청페이지 전체동의 해제
    TERMOK: 'apply.termok', // 참여신청페이지 이용약관 동의 선택
    TERMNO: 'apply.termno', // 참여신청페이지 이용약관 동의 해제
    RECEIPTOK: 'apply.receiptok', // 참여신청페이지 영수증수집 동의 선택
    RECEIPTNO: 'apply.receiptno', // 참여신청페이지 영수증수집 동의 해제
    ADOK: 'apply.adok', // 참여신청페이지 광고 동의 선택
    ADNO: 'apply.adno', // 참여신청페이지 광고 동의 해제
    START: 'apply.start', // 참여신청페이지 플레이스 리뷰어 동의 완료
    CLOSE: 'apply.out', // 참여신청팝업 닫기
  },
  checkin: {
    CS: 'checkin.cs', // 도움말
    EXIT: 'checkin.exit', // 체크인 화면 나가기
    HEADER_BACK: 'checkin.headerback', // 체크인 헤더 백 버튼
    HEADER_MY_PLACE_HOME: 'checkin.headermyplacehome', // 체크인 헤더 홈 버튼
    HIDE_VISIT_WITHOUT_REVIEW_MODAL_NO: `checkin.visithidex`, // 방문내역 > 숨김 모달 > 취소 클릭
    HIDE_VISIT_WITHOUT_REVIEW_MODAL_YES: `checkin.visithideo`, // 방문내역 > 숨김 모달 > 숨기기 클릭
    MEDIA: 'checkin.media', // POV선택>사진/영상 업로드
    NAVER_OPEN_POP_UP_YES: 'checkin.naveropenpoppupyes', // 네이버앱 열기 팝업>확인
    NAVER_OPEN_POPUP_NO: 'checkin.naveropenpoppupno', // 네이버앱 열기 팝업>닫기
    PAY_ALL: 'checkin.payall', // 결제내역 > 전체 보기
    PAY_DELETE_O: 'checkin.paydelo', // 결제내역 > 삭제 설정
    PAY_DELETE_X: 'checkin.paydelx', // 결제내역 > 삭제 취소
    PAY_DELETE: 'checkin.paydel', // 결제내역 > 삭제
    PAY_NUDGE_BANNER: 'checkin.paynbanner', // 결제내역 > 넛지배너
    PAY_NUDGE_CARD: 'checkin.payncard', // 결제내역 > 넛지카드
    PAY_REFRESH: 'checkin.payrefresh', // 결제내역 > 새로 불러오기
    PAY_REVIEW: 'checkin.payreview', // 결제내역 > 리뷰 쓰기
    PAYLOAD: 'checkin.payload', // 결제내역 > 더 보기
    PAYMENT: 'checkin.payment', // POV선택>결제 내역 인증
    RECEIPT: 'checkin.receipt', // POV선택>영수증 인증
    SEARCH: 'checkin.search', // POV선택>직접 장소검색
    UPDATE_CHECK: 'checkin.updatecheck', // 지도앱 업데이트 확인
    UPDATE_CLOSE: 'checkin.updateclose', // 지도앱 업데이트 닫기
    UPDATE_POPUP_NO: 'checkin.updatepoppupno', // 네이버앱 업데이터 팝업>닫기
    UPDATE_POPUP_YES: 'checkin.updatepoppupyes', // 네이버앱 업데이터 팝업>닫기
    VISIT_HIDE: 'checkin.visithide', // 방문내역>숨기기
    VISIT_LOAD_MORE: `checkin.visitload`, // 방문내역 > 더보기
    VISIT_MORE: 'checkin.visitmore', // 방문내역>전체보기
    VISIT_REVIEW: 'checkin.visitreview', // 방문내역>리뷰쓰기
    CLIP: 'checkin.clip', // 체크인 > 클립
    CLIP_TIP: 'checkin.cliptip', // 체크인 > 클립 도움말
    CLIP_TIP_X: 'checkin.cliptipx', // 체크인 > 클립 도움말 닫기
    CLIP_FIRST: 'checkin.clipfirst', // 체크인 > 클립 최초팝업
    CLIP_NAVER_POPUP_X: 'checkin.clipnaverpopupx', // 체크인 > 클립 네이버앱 팝업 취소
    CLIP_NAVER_POPUP_O: 'checkin.clipnaverpopupo', // 체크인 > 클립 네이버앱 팝업 열기
    CLIP_UPDATE_POPUP_X: 'checkin.clipupdatepopupx', // 체크인 > 클립 네이버앱 팝업 취소
    CLIP_UPDATE_POPUP_O: 'checkin.clipupdatepopupo', // 체크인 > 클립 네이버앱 팝업 열기
  },
  defaultListMap: {
    BACK: 'defaultlistmap.back', // 지도(내장소), 뒤로가기 클릭
    MAP: 'defaultlistmap.map', // 지도(내장소), 지도보기 클릭
    DESCLIST: 'defaultlistmap.desclist', // 지도(내장소), 목록화면 카드 설명영역 클릭
    PHOTOLIST: 'defaultlistmap.photolist', // 지도(내장소), 목록화면 카드 사진영역 클릭
    LIST: 'defaultlistmap.list', // 지도(내장소), 목록보기 클릭
    NOW: 'defaultlistmap.now', // 지도(내장소), 현재 위치보기 클릭
    SATELLITE: 'defaultlistmap.satellite', // 지도(내장소), 위성지도 보기 클릭
    ROAD: 'defaultlistmap.road', // 지도(내장소), 거리뷰 보기 클릭
    ENLARGE: 'defaultlistmap.enlarge', // 지도(내장소), 줌 확대 클릭
    REDUCE: 'defaultlistmap.reduce', // 지도(내장소), 줌 축소 클릭
    PLACE: 'defaultlistmap.place', // 지도(내장소), 장소 팝업 보기 클릭
    PLACES: 'defaultlistmap.places', // 지도(내장소), 장소 클러스터링 팝업 보기 클릭
    DESC: 'defaultlistmap.desc', // 지도(내장소), 장소 팝업(요약카드)에서 장소 디테일 보기 클릭
    PHOTO: 'defaultlistmap.photo', // 지도(내장소), 장소 팝업(요약카드)에서 사진영역 클릭
    REV: 'defaultlistmap.rev', // 지도(내장소), 장소 팝업(요약카드)에서 예약 클릭
    CALL: 'defaultlistmap.call', // 지도(내장소), 장소 팝업(요약카드)에서 전화 클릭
    SAVE: 'defaultlistmap.save', // 지도(내장소), 장소 팝업(요약카드)에서 저장 클릭
    UNSAVE: 'defaultlistmap.unsave', // 지도(내장소), 장소 팝업(요약카드)에서 저장취소 클릭
    PATH: 'defaultlistmap.path', // 지도(내장소), 장소 팝업(요약카드)에서 길찾기 클릭
    SHARE: 'defaultlistmap.share', // 지도(내장소), 장소 팝업(요약카드)에서 공유 클릭
    DELETE: 'defaultlistmap.delete', // 지도(내장소), 장소 삭제하기 클릭
    DELETENO: 'defaultlistmap.deleteno', // 지도(내장소), 삭제확인 팝업에서 취소 클릭
    DELETEYES: 'defaultlistmap.deleteyes', // 지도(내장소), 삭제확인 팝업에서 삭제 클릭
    OK: 'defaultlistmap.ok', // 지도(내장소), 장소정보 팝업에서 확인 클릭
  },
  editArea: {
    CLOSE: 'editarea.close', // 관심지역설정 > 닫기버튼클릭
    TEXTINPUT: 'editarea.textinput', // 관심지역설정 > 검색영역클릭
    ADDCARD: 'editarea.addcard', // 관심지역설정 > 추천지역 추가
    CANCELCARD: 'editarea.cancelcard', // 관심지역설정 > 추천지역 추가 취소
    SAVE: 'editarea.save', // 관심지역설정 > 저장버튼 클릭
    DELETEALL: 'editarea.deleteall', // 관심지역설정 > 전체삭제 클릭
    LISTORDER: 'editarea.listorder', // 관심지역설정 > 리스트 순서변경 클릭
    LISTDELETE: 'editarea.listdelete', // 관심지역설정 > 리스트삭제 클릭
    POPUPNO: 'editarea.popupno', // 관심지역설정 > 닫기팝업 아니요 클릭
    POPUPYES: 'editarea.popupyes', // 관심지역설정 > 닫기팝업 예 클릭
    BACK: 'editarea.back', // 관심지역설정 > 검색 뒤로가기 클릭
    SEARCH: 'editarea.search', // 관심지역설정 > 검색 클릭
    TEXTX: 'editarea.textx', // 관심지역설정 > 검색 입력 삭제
    SELECT: 'editarea.select', // 관심지역설정 > 검색 선택
    ADDSGAREA: 'editarea.addsgarea', // 관심지역설정 > 개인추천지역선택
    CANCELSGAREA: 'editarea.cancelsgarea', // 관심지역설정 > 개인추천지역선택취소
  },
  editTheme: {
    BACK: 'edittheme.back', // 뒤로가기
    TITLE: 'edittheme.title', // 타이틀입력
    DESC: 'edittheme.desc', // 설명 입력
    COVER: 'edittheme.cover', // 커버 변경
    PUBLIC: 'edittheme.public', // 공개
    PRIVATE: 'edittheme.private', // 비공개
    ADDREVIEW: 'edittheme.addreview', // 리뷰 추가하기
    ORDER: 'edittheme.order', // 순서변경
    DELETEALL: 'edittheme.deleteall', // 전체삭제
    COMPLETE: 'edittheme.complete', // 테마등록
    DELETEOK: 'edittheme.deleteok', // 팝업_전체삭제OK
    DELETENO: 'edittheme.deleteno', // 팝업_전체삭제취소
    PRIVATEOK: 'edittheme.privateok', // 팝업_비공개로저장
    PRIVATENO: 'edittheme.privateno', // 팝업_비공개저장취소
    NOTEXTOK: 'edittheme.notextok', // 팝업_텍스트x리뷰포함알림
  },
  feed: {
    ADDAREA: 'feed2.addarea', // 피드탭, 지역탭 관심지역 추가 클릭
    AREATAB: 'feed2.areatab', // 피드탭, 지역탭 관심지역 클릭
    EDITAREA: 'feed2.editarea', // 피드탭, 지역탭 관심지역 수정 클릭
    REGIONALL: 'feed2.regionall', // 피드탭, 지역탭 전체 클릭
    REGIONAR: 'feed2.regionar', // 피드탭, 지역탭 내주변 클릭
    REGIONCOMING: 'feed2.regioncoming', // 피드탭, 지역탭 커밍쑨 클릭
    CATEGORYKRON: 'feed2.categorykron', // 피드탭, 업종탭 한식 선택
    CATEGORYKROFF: 'feed2.categorykroff', // 피드탭, 업종탭 한식 취소
    CATEGORYWTON: 'feed2.categorywton', // 피드탭, 업종탭 양식 선택
    CATEGORYWTOFF: 'feed2.categorywtoff', // 피드탭, 업종탭 양식 취소
    CATEGORYCHON: 'feed2.categorychon', // 피드탭, 업종탭 중식 선택
    CATEGORYCHOFF: 'feed2.categorycafeoff', // 피드탭, 업종탭 중식 취소
    CATEGORYJPON: 'feed2.categoryjpon', // 피드탭, 업종탭 일식 선택
    CATEGORYJPOFF: 'feed2.categoryjpoff', // 피드탭, 업종탭 일식 취소
    CATEGORYAFON: 'feed2.categoryafon', // 피드탭, 업종탭 아시아퓨전 선택
    CATEGORYAFOFF: 'feed2.categoryafoff', // 피드탭, 업종탭 아시아퓨전 취소
    CATEGORYCDON: 'feed2.categorycdon', // 피드탭, 업종탭 카페디저트 선택
    CATEGORYCDOFF: 'feed2.categorycdoff', // 피드탭, 업종탭 카페디저트 취소
    CATEGORYSCON: 'feed2.categoryscon', // 피드탭, 업종탭 분식치킨 선택
    CATEGORYSCOFF: 'feed2.categoryscoff', // 피드탭, 업종탭 분식치킨 취소
    CATEGORYBAON: 'feed2.categorybaon', // 피드탭, 업종탭 술집 선택
    CATEGORYBAOFF: 'feed2.categorybaoff', // 피드탭, 업종탭 술집 취소
    CATEGORYBFON: 'feed2.categorybfon', // 피드탭, 업종탭 뷔페기타 선택
    CATEGORYBFOFF: 'feed2.categorybfoff', // 피드탭, 업종탭 뷔페기타 취소
    CATEGORYPION: 'feed2.categorypion', // 피드탭, 업종탭 피크닉 선택
    CATEGORYPIOFF: 'feed2.categorypioff', // 피드탭, 업종탭 피크닉 취소
    CATEGORYCLON: 'feed2.categoryclon', // 피드탭, 업종탭 문화예술 선택
    CATEGORYCLOFF: 'feed2.categorycloff', // 피드탭, 업종탭 문화예술 취소
    CATEGORYWKON: 'feed2.categorywkon', // 피드탭, 업종탭 아이와 함께 선택
    CATEGORYWKOFF: 'feed2.categorywkoff', // 피드탭, 업종탭 아이와 함께 취소
    CATEGORYNAON: 'feed2.categorynaon', // 피드탭, 업종탭 자연명소 선택
    CATEGORYNAOFF: 'feed2.categorynaoff', // 피드탭, 업종탭 자연명소 취소
    CATEGORYHION: 'feed2.categoryhion', // 피드탭, 업종탭 역사유적 선택
    CATEGORYHIOFF: 'feed2.categoryhioff', // 피드탭, 업종탭 역사유적 취소
    CATEGORYEXON: 'feed2.categoryexon', // 피드탭, 업종탭 체험관광 선택
    CATEGORYEXOFF: 'feed2.categoryexoff', // 피드탭, 업종탭 체험관광 취소
    CATEGORYTHON: 'feed2.categorython', // 피드탭, 업종탭 테마파크 선택
    CATEGORYTHOFF: 'feed2.categorythoff', // 피드탭, 업종탭 테마파크 취소
    CATEGORYWAON: 'feed2.categorywaon', // 피드탭, 업종탭 물놀이 선택
    CATEGORYWAOFF: 'feed2.categorywaoff', // 피드탭, 업종탭 물놀이 취소
    CATEGORYCAON: 'feed2.categorycaon', // 피드탭, 업종탭 캠핑 선택
    CATEGORYCAOFF: 'feed2.categorycaoff', // 피드탭, 업종탭 캠핑 취소
    CATEGORYLEON: 'feed2.categoryleon', // 피드탭, 업종탭 레저/액티비티 선택
    CATEGORYLEOFF: 'feed2.categoryleoff', // 피드탭, 업종탭 레저/액티비티 취소
    CATEGORYTRON: 'feed2.categorytron', // 피드탭, 업종탭 등산/트래킹 선택
    CATEGORYTROFF: 'feed2.categorytroff', // 피드탭, 업종탭 등산/트래킹 취소
    CATEGORYFION: 'feed2.categoryfion', // 피드탭, 업종탭 낚시 선택
    CATEGORYFIOFF: 'feed2.categoryfioff', // 피드탭, 업종탭 낚시 취소
    CATEGORYCRON: 'feed2.categorycron', // 피드탭, 업종탭 클래스/소품 선택
    CATEGORYCROFF: 'feed2.categorycroff', // 피드탭, 업종탭 클래스/소품 취소
    CATEGORYLOON: 'feed2.categoryloon', // 피드탭, 업종탭 숙박 선택
    CATEGORYLOOFF: 'feed2.categorylooff', // 피드탭, 업종탭 숙박 취소
    CATEGORYWION: 'feed2.categorywion', // 피드탭, 업종탭 겨울레포츠 선택
    CATEGORYWIOFF: 'feed2.categorywioff', // 피드탭, 업종탭 겨울레포츠 취소
    FOLREVIEWPROFILE: 'feed2.folreviewprofile', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 프로필 클릭
    FOLREVIEWFOL: 'feed2.folreviewfol', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 팔로우 클릭
    FOLREVIEWUNFOL: 'feed2.folreviewunfol', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 팔로우 취소 클릭
    FOLREVIEWREQCANCEL: 'feed2.folreviewreqcancel', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 팔로우 신청 취소 클릭
    FOLREVIEWIMAGE: 'feed2.folreviewimage', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 이미지 클릭
    FOLREVIEWTEXT: 'feed2.folreviewtext', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 텍스트 클릭
    FOLREVIEWTEXTOPEN: 'feed2.folreviewtextopen', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 텍스트 펼침 클릭
    FOLREVIEWTEXTCLOSE: 'feed2.folreviewtextclose', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 텍스트 접기 클릭
    FOLREVIEWFULLKEYWORD: 'feed2.folreviewfullkeyword', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 키워드 펼침 클릭
    FOLREVIEWPLACE: 'feed2.folreviewplace', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 장소 클릭
    FOLREVIEWSAVE: 'feed2.folreviewsave', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 장소 저장 클릭
    FOLREVIEWUNSAVE: 'feed2.folreviewunsave', // 전체탭 팔로잉 유저 피드탭, 리뷰카드 장소 저장 취소 클릭
    FOLREVIEWCALL: 'feed2.folreviewcall', // 전체탭 팔로잉 유저 피드탭, 이전 리뷰 더 불러오기 클릭
    NEWREVIEWPROFILE: 'feed2.newreviewprofile', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 프로필 클릭
    NEWREVIEWFOL: 'feed2.newreviewfol', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 팔로우 클릭
    NEWREVIEWUNFOL: 'feed2.newreviewunfol', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 팔로우 취소 클릭
    NEWREVIEWREQCANCEL: 'feed2.newreviewreqcancel', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 팔로우 신청 취소 클릭
    NEWREVIEWIMAGE: 'feed2.newreviewimage', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 이미지 클릭
    NEWREVIEWTEXT: 'feed2.newreviewtext', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 텍스트 클릭
    NEWREVIEWTEXTOPEN: 'feed2.newreviewtextopen', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 텍스트 펼침 클릭
    NEWREVIEWTEXTCLOSE: 'feed2.newreviewtextclose', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 텍스트 접기 클릭
    NEWREVIEWFULLKEYWORD: 'feed2.newreviewfullkeyword', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 키워드 펼침 클릭
    NEWREVIEWPLACE: 'feed2.newreviewplace', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 장소 클릭
    NEWREVIEWSAVE: 'feed2.newreviewsave', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 장소 저장 클릭
    NEWREVIEWUNSAVE: 'feed2.newreviewunsave', // 전체탭 지역 최신 유저 피드탭, 리뷰카드 장소 저장 취소 클릭
    NEWREVIEWINFO: 'feed2.newreviewinfo', // 전체탭 지역 최신 유저 피드탭, 제목 안내 클릭
    NEWREVIEWINFOCLOSE: 'feed2.newreviewinfoclose', // 전체탭 지역 최신 유저 피드탭, 제목 안내 닫기 클릭
    REVIEWPROFILE: 'feed2.reviewprofile', // 피드탭, 리뷰카드 프로필 클릭
    REVIEWFOL: 'feed2.reviewfol', // 피드탭, 리뷰카드 팔로우 클릭
    REVIEWUNFOL: 'feed2.reviewunfol', // 피드탭, 리뷰카드 팔로우 취소 클릭
    REVIEWREQCANCEL: 'feed2.reviewreqcancel', // 피드탭, 리뷰카드 팔로우 신청 취소 클릭
    REVIEWIMAGE: 'feed2.reviewimage', // 피드탭, 리뷰카드 이미지 클릭
    REVIEWTEXT: 'feed2.reviewtext', // 피드탭, 리뷰카드 텍스트 클릭
    REVIEWTEXTOPEN: 'feed2.reviewtextopen', // 피드탭, 리뷰카드 텍스트 펼침 클릭
    REVIEWTEXTCLOSE: 'feed2.reviewtextclose', // 피드탭, 리뷰카드 텍스트 접기 클릭
    REVIEWFULLKEYWORD: 'feed2.reviewfullkeyword', // 피드탭, 리뷰카드 키워드 펼침 클릭
    REVIEWPLACE: 'feed2.reviewplace', // 피드탭, 리뷰카드 장소 클릭
    RFOLREVIEWPROFILE: 'feed2.rfolreviewprofile', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 프로필 클릭
    RFOLREVIEWFOL: 'feed2.rfolreviewfol', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 팔로우 클릭
    RFOLREVIEWUNFOL: 'feed2.rfolreviewunfol', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 팔로우 취소 클릭
    RFOLREVIEWREQCANCEL: 'feed2.rfolreviewreqcancel', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 팔로우 신청 취소 클릭
    RFOLREVIEWIMAGE: 'feed2.rfolreviewimage', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 이미지 클릭
    RFOLREVIEWTEXT: 'feed2.rfolreviewtext', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 텍스트 클릭
    RFOLREVIEWTEXTOPEN: 'feed2.rfolreviewtextopen', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 텍스트 펼침 클릭
    RFOLREVIEWTEXTCLOSE: 'feed2.rfolreviewtextclose', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 텍스트 접기 클릭
    RFOLREVIEWFULLKEYWORD: 'feed2.rfolreviewfullkeyword', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 키워드 펼침 클릭
    RFOLREVIEWPLACE: 'feed2.rfolreviewplace', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 장소 클릭
    RFOLREVIEWSAVE: 'feed2.rfolreviewsave', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 장소 저장 클릭
    RFOLREVIEWUNSAVE: 'feed2.rfolreviewunsave', // 관심지역&현위치탭 팔로잉 유저 피드탭, 리뷰카드 장소 저장 취소 클릭
    RFOLREVIEWCALL: 'feed2.rfolreviewcall', // 관심지역&현위치탭 팔로잉 유저 피드탭, 이전 리뷰 더 불러오기 클릭
    RNEWREVIEWPROFILE: 'feed2.rnewreviewprofile', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 프로필 클릭
    RNEWREVIEWFOL: 'feed2.rnewreviewfol', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 팔로우 클릭
    RNEWREVIEWUNFOL: 'feed2.rnewreviewunfol', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 팔로우 취소 클릭
    RNEWREVIEWREQCANCEL: 'feed2.rnewreviewreqcancel', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 팔로우 신청 취소 클릭
    RNEWREVIEWIMAGE: 'feed2.rnewreviewimage', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 이미지 클릭
    RNEWREVIEWTEXT: 'feed2.rnewreviewtext', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 텍스트 클릭
    RNEWREVIEWTEXTOPEN: 'feed2.rnewreviewtextopen', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 텍스트 펼침 클릭
    RNEWREVIEWTEXTCLOSE: 'feed2.rnewreviewtextclose', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 텍스트 접기 클릭
    RNEWREVIEWFULLKEYWORD: 'feed2.rnewreviewfullkeyword', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 키워드 펼침 클릭
    RNEWREVIEWPLACE: 'feed2.rnewreviewplace', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 장소 클릭
    RNEWREVIEWSAVE: 'feed2.rnewreviewsave', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 장소 저장 클릭
    RNEWREVIEWUNSAVE: 'feed2.rnewreviewunsave', // 관심지역&현위치탭 지역 최신 유저 피드탭, 리뷰카드 장소 저장 취소 클릭
    REVIEWSAVE: 'feed2.reviewsave', // 피드탭, 리뷰카드 장소 저장 클릭
    REVIEWUNSAVE: 'feed2.reviewunsave', // 피드탭, 리뷰카드 장소 저장 취소 클릭
    CONMORE: 'feed2.conmore', // 피드탭, 리뷰카드 더보기 클릭
    REPORT: 'feed2.report', // 피드 더보기>리뷰/리뷰어신고
    BLOCK: 'feed2.reviewerblock', // 피드탭>리뷰>더보기>리뷰어차단
    REGIONREVIEWERPROFILE: 'feed2.regionreviewerprofile', // 피드탭, 리뷰어 프로필 클릭
    REGIONREVIEWERFOL: 'feed2.regionreviewerfol', // 피드탭, 리뷰어 팔로우 클릭
    REGIONREVIEWERUNFOL: 'feed2.regionreviewerunfol', // 피드탭, 리뷰어 팔로우 취소 클릭
    REGIONREVIEWERREQCANCEL: 'feed2.regionreviewerreqcancel', // 피드탭, 리뷰어 팔로우 신청 취소 클릭
    REGIONREVIEWERIMAGE: 'feed2.regionreviewerimage', // 피드탭, 리뷰어 이미지 클릭
    REGIONREVIEWERDEL: 'feed2.regionreviewerdel', // 피드탭, 리뷰어 삭제 클릭
    REGIONREVIEWERDELCANCEL: 'feed2.regionreviewerdelcancel', // 피드탭, 리뷰어 삭제 취소 클릭
    REGIONWHOLE: 'feed2.regionwhole', // 피드탭, 지역탭에서 전체탭 클릭
    TASTEREVIEWERPROFILE: 'feed2.tastereviewerprofile', // 피드탭, 취향 리뷰어 프로필 클릭
    TASTEREVIEWERFOL: 'feed2.tastereviewerfol', // 피드탭, 취향 리뷰어 팔로우 클릭
    TASTEREVIEWERUNFOL: 'feed2.tastereviewerunfol', // 피드탭, 취향 리뷰어 팔로우 취소 클릭
    TASTEREVIEWERREQCANCEL: 'feed2.tastereviewerreqcancel', // 피드탭, 취향 리뷰어 팔로우 신청 취소 클릭
    TASTEREVIEWERIMAGE: 'feed2.tastereviewerimage', // 피드탭, 취향 리뷰어 이미지 클릭
    TASTEREVIEWERDEL: 'feed2.tastereviewerdel', // 피드탭, 취향 리뷰어 삭제 클릭
    TASTEREVIEWERDELCANCEL: 'feed2.tastereviewerdelcancel', // 피드탭, 취향 리뷰어 삭제 취소 클릭
    AGEREVIEWERPROFILE: 'feed2.agereviewerprofile', // 피드탭, 연령별 리뷰어 프로필 클릭
    AGEREVIEWERFOL: 'feed2.agereviewerfol', // 피드탭, 연령별 리뷰어 팔로우 클릭
    AGEREVIEWERUNFOL: 'feed2.agereviewerunfol', // 피드탭, 연령별 리뷰어 팔로우 취소 클릭
    AGEREVIEWERREQCANCEL: 'feed2.agereviewerreqcancel', // 피드탭, 연령별 리뷰어 팔로우 신청 취소 클릭
    AGEREVIEWERIMAGE: 'feed2.agereviewerimage', // 피드탭, 연령별 리뷰어 이미지 클릭
    AGEREVIEWERDEL: 'feed2.agereviewerdel', // 피드탭, 연령별 리뷰어 삭제 클릭
    AGEREVIEWERDELCANCEL: 'feed2.agereviewerdelcancel', // 피드탭, 연령별 리뷰어 삭제 취소 클릭
    MENUREVIEWERPROFILE: 'feed2.menureviewerprofile', // 피드탭, 메뉴별 리뷰어 프로필 클릭
    MENUREVIEWERFOL: 'feed2.menureviewerfol', // 피드탭, 메뉴별 리뷰어 팔로우 클릭
    MENUREVIEWERUNFOL: 'feed2.menureviewerunfol', // 피드탭, 메뉴별 리뷰어 팔로우 취소 클릭
    MENUREVIEWERREQCANCEL: 'feed2.menureviewerreqcancel', // 피드탭, 메뉴별 리뷰어 팔로우 신청 취소 클릭
    MENUREVIEWERIMAGE: 'feed2.menureviewerimage', // 피드탭, 메뉴별 리뷰어 이미지 클릭
    MENUREVIEWERDEL: 'feed2.menureviewerdel', // 피드탭, 메뉴별 리뷰어 삭제 클릭
    MENUREVIEWERDELCANCEL: 'feed2.menureviewerdelcancel', // 피드탭, 메뉴별 리뷰어 삭제 취소 클릭
    LIST: 'feed.list', // 발견탭 리스트 제목 클릭
    LISTPLACE: 'feed.listplace', // 발견탭 리스트 개별장소 클릭
    LISTPROFILE: 'feed.listprofile', // 발견탭 리스트 프로필 클릭
    SAVELIST: 'feed.savelist', // 발견탭 리스트 저장 클릭
    UNSAVELIST: 'feed.unsavelist', // 발견탭 리스트 저장취소 클릭
    MORELIST: 'feed.morelist', // 발견탭 리스트 더보기 클릭
    MOREPLACE: 'feed.moreplace', // 발견탭 리스트 장소 더보기 클릭
    LISTSWIPE: 'feed.listswipe', // 발견탭 리스트 넘겨보기
    REVIEW: 'feed.review', // 발견탭 리스트 리뷰 클릭
    GOSURVEY: 'feed.gosurvey', // 발견탭 응모완료 모달 설문 참여하기 클릭
    SURVEYCLOSE: 'feed.surveyclose', // 발견탭 응모완료 모달 닫기 클릭
    LOCATIONHELP: 'feed2.locationhelp', // 피드탭 위치설정 토스트 도움말 클릭
    THEMELIST: 'feed2.themelist', // 피드탭 테마리스트 클릭
    THEMELISTMAKE: 'feed2.themelistmake', // 피드탭 테마리스트 내 리뷰만 모아 테마 만들기
    ONBOARDING: 'feed2.onboarding', // 온보딩 카드
    ONBOARDINGCLOSE: 'feed2.onboardingclose', // 온보딩 카드 닫기
    ONBOARDINGDONE: 'feed2.onboardingdone', // 온보딩 완료
    TRIPPLACEMORE: 'feed2.tripplacemore', // 가볼만한곳 장소 더보기
    TRIPPLACE: 'feed2.tripplace', // 가볼만한곳
    ONBOARDINGLOGOUT: 'feed2.onboardinglogout', // 온보딩 카드 비로그인
    ONBOARDING_0_ALL: 'feed2.onboarding0all', // 온보딩카드 미진행 공통
    ONBOARDING_0_PR: 'feed2.onboarding0pr', // 온보딩카드 미진행 개인
    ONBOARDING_1_ALL: 'feed2.onboarding1all', // 온보딩카드 1단계진행중 공통
    ONBOARDING_1_PR: 'feed2.onboarding1pr', // 온보딩카드 1단계진행중 개인
    ONBOARDING_2_ALL: 'feed2.onboarding2all', // 온보딩카드 2단계진행중
    ONBOARDING_3_ALL: 'feed2.onboarding3all', // 온보딩카드 3단계진행중 공통
    ONBOARDING_3_PR: 'feed2.onboarding3pr', // 온보딩카드 3단계진행중 개인
    ORFOLREVIEWALL: 'feed2.orfolreviewall', // 관심지역외팔로잉리뷰>전체보기
    ORFOLREVIEWIMAGE: 'feed2.orfolreviewimage', // 관심지역외팔로잉리뷰>이미지
    ORFOLREVIEWTEXT: 'feed2.orfolreviewtext', // 관심지역외팔로잉리뷰>텍스트
    ORFOLREVIEWPROFILE: 'feed2.orfolreviewprofile', // 관심지역외팔로잉리뷰>프로필
    ORFOLREVIEWMORE: 'feed2.orfolreviewmore', // 관심지역외팔로잉리뷰>더보기
  },
  // 피드탭 > 팔로잉 리뷰 제외 리액션
  feedReaction: {
    REACT_FIRST: 'feed2.reactfirst', // 반응남기기(0개)
    REACT: 'feed2.react', // 반응 남기기(1개 이상)
    HELPFUL: 'feed2.helpful', // 리액션 선택- 도움돼요
    WANNAGO: 'feed2.wannago', // 리액션 선택- 가고싶어요
    FUN: 'feed2.fun', // 리액션 선택- 재밌어요
    COOL: 'feed2.cool', // 리액션 선택- 멋져요
    REACT_LIST: 'feed2.reactlist', // 반응한 사람 목록
    EMOJITAB: 'feed2.emojitab', // 반응한 사람 목록 > 리액션별탭
    REACT_PROFILE: 'feed2.reactprofile', // 반응한 사람 목록 > 프로필
    REACT_FOL: 'feed2.reactfol', // 반응한 사람 목록 > 팔로우
    REACT_UNFOL: 'feed2.reactunfol', // 반응한 사람 목록 > 팔로우해제
  },
  // 피드탭 > 팔로잉 리뷰 리액션
  feedFollowingReaction: {
    REACT_FIRST: 'feed2.folreactfirst', // 반응남기기(0개)
    REACT: 'feed2.folreact', // 반응 남기기(1개 이상)
    HELPFUL: 'feed2.folhelpful', // 리액션 선택- 도움돼요
    WANNAGO: 'feed2.folwannago', // 리액션 선택- 가고싶어요
    FUN: 'feed2.folfun', // 리액션 선택- 재밌어요
    COOL: 'feed2.folcool', // 리액션 선택- 멋져요
    REACT_LIST: 'feed2.folreactlist', // 반응한 사람 목록
    EMOJITAB: 'feed2.folemojitab', // 반응한 사람 목록 > 리액션별탭
    REACT_PROFILE: 'feed2.folreactprofile', // 반응한 사람 목록 > 프로필
    REACT_FOL: 'feed2.folreactfol', // 반응한 사람 목록 > 팔로우
    REACT_UNFOL: 'feed2.folreactunfol', // 반응한 사람 목록 > 팔로우해제
  },
  followListMyFollower: {
    FOLLOW: 'myfollowlist.followerfol', // 본인팔로워탭>팔로우하기
    UNFOLLOW: 'myfollowlist.followerunfol', // 본인팔로워탭>팔로잉취소
    FOLLOWREQUESTCANCEL: 'myfollowlist.followerreqcancel', // 본인팔로워탭>팔로우신청취소
  },
  followListMyFollowing: {
    FOLLOW: 'myfollowlist.followingfol', // 본인팔로잉탭>팔로잉
    UNFOLLOW: 'myfollowlist.followingunfol', // 본인팔로잉탭>팔로잉취소
    FOLLOWREQUESTCANCEL: 'myfollowlist.followingreqcancel', // 본인팔로잉탭>팔로우신청취소
  },
  followListMyBlocking: {
    FOLLOW: 'myfollowlist.blockfol', // 본인팔로워탭>팔로우하기
    UNFOLLOW: 'myfollowlist.blockunfol', // 본인팔로워탭>팔로잉취소
    FOLLOWREQUESTCANCEL: 'myfollowlist.blockregcancel', // 본인팔로워탭>팔로우신청취소
  },
  followListMy: {
    BACK: 'myfollowlist.back', // 뒤로가기
    FOLLOWINGTAB: 'myfollowlist.followingtab', // 본인팔로잉탭
    FOLLOWINGPROFILE: 'myfollowlist.followingprofile', // 본인팔로잉탭>유저프로필
    FOLLOWINGMORE: 'myfollowlist.followingmore', // 본인팔로잉탭>더보기
    FOLLOWERTAB: 'myfollowlist.followertab', // 본인팔로워탭
    FOLLOWERMORE: 'myfollowlist.followermore', // 본인팔로워탭>더보기
    AUTOFOLOK: 'myfollowlist.autofolok', // 본인팔로워탭>팔로우자동수락
    AUTOFOLNO: 'myfollowlist.autofolno', // 본인팔로워탭>팔로우수동수락
    REQPROFILE: 'myfollowlist.reqprofile', // 본인팔로워탭>신청유저프로필
    REQOK: 'myfollowlist.reqok', // 본인팔로워탭>신청수락
    REQDELETE: 'myfollowlist.reqdelete', // 본인팔로워탭>신청삭제
    REQMORE: 'myfollowlist.reqmore', // 본인팔로워탭>신청더보기
    FOLLOWERPROFILE: 'myfollowlist.followerprofile', // 본인팔로워탭>유저프로필
    PLACEMY: 'myfollowlist.placemy', // MY플레이스 홈 클릭
    BLOCKMORE: 'myfollowlist.blockmore', // 본인차단탭>더보기
    BLOCKPROFILE: 'myfollowlist.blockprofile', // 본인차단탭>유저프로필
    FOLLOWINGBLOCK: 'myfollowlist.followingblock', // 본인팔로잉탭>팔로잉리뷰어>더보기>리뷰어차단
    FOLLOWINGCONMORE: 'myfollowlist.followingconmore', // 본인팔로잉탭>팔로잉리뷰어>더보기
    FOLLOWERREQBLOCK: 'myfollowlist.followerreqblock', // 본인팔로워탭>팔로우신청>더보기>리뷰어차단
    FOLLOWERREQCONMORE: 'myfollowlist.followerreqconmore', // 본인팔로워탭>팔로우신청>더보기
    FOLLOWERDELETE: 'myfollowlist.followerdelete', // 본인팔로워탭>팔로워리뷰어>더보기>리뷰어삭제
    FOLLOWERBLOCK: 'myfollowlist.followerblock', // 본인팔로워탭>팔로워리뷰어>더보기>리뷰어차단
    FOLLOWERCONMORE: 'myfollowlist.followerconmore', // 본인팔로워탭>팔로워리뷰어>더보기
    BLOCKTAB: 'myfollowlist.blocktab', // 본인차단탭
    REVIEWERUNBLOCK: 'myfollowlist.reviewerunblock', // 본인차단탭>리뷰어차단해제
    REVIEWERBLOCK: 'myfollowlist.reviewerblock', // 본인차단탭>리뷰어차단
  },
  followListYourFollower: {
    FOLLOW: 'yourfollowlist.followerfol', // 타인팔로워탭>팔로우하기
    UNFOLLOW: 'yourfollowlist.followerunfol', // 타인팔로워탭>팔로잉취소
    FOLLOWREQUESTCANCEL: 'yourfollowlist.followerreqcancel', // 타인팔로워탭>팔로우신청취소
  },
  followListYourFollowing: {
    FOLLOW: 'yourfollowlist.followingfol', // 타인팔로잉탭>팔로우하기
    UNFOLLOW: 'yourfollowlist.followingunfol', // 타인팔로잉탭>팔로잉취소
    FOLLOWREQUESTCANCEL: 'yourfollowlist.followingreqcancel', // 타인팔로잉탭>팔로우신청취소
  },
  followListYour: {
    BACK: 'yourfollowlist.back', // 뒤로가기
    FOLLOWINGTAB: 'yourfollowlist.followingtab', // 타인팔로잉탭
    FOLLOWINGPROFILE: 'yourfollowlist.followingprofile', // 타인팔로잉탭>유저프로필
    FOLLOWINGMORE: 'yourfollowlist.followingmore', // 타인팔로잉탭>더보기
    FOLLOWERTAB: 'yourfollowlist.followertab', // 타인팔로워탭
    FOLLOWERPROFILE: 'yourfollowlist.followerprofile', // 타인팔로워탭>유저프로필
    FOLLOWERMORE: 'yourfollowlist.followermore', // 타인팔로워탭>더보기
  },
  followPopup: {
    CLOSE: 'followpopup.close', // 팔로우안내팝업>닫기
    MORE: 'followpopup.more', // 팔로우안내팝업>자세히보기
    AUTOFOLOK: 'followpopup.autofolok', // 팔로우안내팝업>자동수락체크
    AUTOFOLNO: 'followpopup.autofolno', // 팔로우안내팝업>자동수락언체크
    OK: 'followpopup.ok', // 팔로우안내팝업>확인
    UNFOLNO: 'followpopup.unfolno', // 언팔로우취소
    UNFOLOK: 'followpopup.unfolok', // 언팔로우확인
    REQCANCELNO: 'followpopup.reqcancelno', // 팔로우신청취소를취소
    REQCANCELOK: 'followpopup.reqcancelok', // 팔로우신청취소확인
    FEEDGUIDE: 'followpopup.feedguide', // 팔로우시토스트>피드보기
    REQ_LIMIT_CLOSE: 'followpopup.reqlimitclose', // 팔로우신청대기제한팝업>확인
  },
  footer: {
    TERMS: 'footer.terms', // 푸터, 네이버 이용약관 클릭
    CS: 'footer.cs', // 푸터, 고객센터 클릭
    REPORT: 'footer.report', // 푸터, 신고센터 클릭
    NOTICE: 'footer.notice', // 푸터, 공지사항 클릭
    NAVER: 'footer.naver', // 푸터, 네이버로고 클릭
  },
  gnb: {
    NAVER: 'gnb.naver', // gnb 네이버 클릭
    PARTICIPATE: 'gnb.participate', // gnb 타인뷰 참여하기 클릭
    PLACEMY: 'gnb.placemy', // gnb 마이플레이스 클릭
    PROFILE: 'gnb.profile', // gnb 프로 클릭
    ADDMAIN: 'gnb.addmain', // gnb 메인에추가 클릭
    VISIT: 'gnb.visit', // gnb 방문내역 클릭
    SMARTORDER: 'gnb.smartorder', // gnb 네이버주문 클릭
    WARNINGGUIDE: 'gnb.warningguide', // gnb 경고팝업 가이드보기 클릭
    WARNINGCLOSE: 'gnb.warningclose', // gnb 경고팝업 닫기 클릭
    WARNINGPOLICY: 'gnb.warningpolicy', // gnb 경고팝업 이용정책링크
    WARNING_2_GUIDE: 'gnb.warning2guide', // gnb 2차경고팝업 가이드보기 클릭
    WARNING_2_CLOSE: 'gnb.warning2close', // gnb 2차경고팝업 닫기 클릭
    WARNING_3_GUIDE: 'gnb.warning3guide', // gnb 3차경고팝업 가이드보기 클릭
    WARNING_3_CLOSE: 'gnb.warning3close', // gnb 3차경고팝업 닫기 클릭
    BLACKCLOSE: 'gnb.blackclose', // gnb 블랙팝업 닫기 클릭
    BLACKGUIDE: 'gnb.blackguide', // gnb 블랙팝업 가이드보기 클릭
    BLACKPOLICY: 'gnb.blackpolicy', // gnb 블랙팝업 이용정책링크
    PCSMARTORDER: 'gnb.pcsmartorder', // gnb 네이버주문 클릭(PC)
    PCSMARTORDERPOPUP: 'gnb.pcsmartorderpopup', // gnb 네이버주문 모바일만 가능 안내 레이어 확인 클릭
    MAP: 'gnb.map', // gnb 지도 아이콘 클릭
    FOLLOW: 'gnb.yourprofilefol', // 타인프로필>팔로우하기
    UNFOLLOW: 'gnb.yourprofileunfol ', // 타인프로필>팔로잉취소
    FOLLOWREQUESTCANCEL: 'gnb.yourprofilefollowreqcancel', // 타인프로필>팔로우신청취소
    MYPROFILEVISIT: 'gnb.myprofilevisit', // 본인프로필>방문카운팅
    MYPROFILEREVIEW: 'gnb.myprofilereview', // 본인프로필>리뷰카운팅
    MYPROFILEFOLLOWING: 'gnb.myprofilefollowing', // 본인프로필>팔로잉카운팅
    MYPROFILEFOLLOWER: 'gnb.myprofilefollower', // 본인프로필>팔로워카운팅
    YOURPROFILEREVIEW: 'gnb.yourprofilereview', // 타인프로필>리뷰카운팅
    YOURPROFILEFOLLOWING: 'gnb.yourprofilefollowing', // 타인프로필>팔로잉카운팅
    YOURPROFILEFOLLOWER: 'gnb.yourprofilefollower', // 타인프로필>팔로워카운팅
    TIP: 'gnb.tip', // 본인뷰프로필>프로필툴팁
    MENU: 'gnb.menu', // 본인뷰프로필>삼선메뉴
    MYINTROMORE: 'gnb.myintromore', // 본인뷰프로필>소개더보기
    SHARE: 'gnb.share', // 본인뷰프로필>프로필공유
    INTROMORE: 'gnb.intromore', // 본인뷰프로필>소개더보기
    SHAREPROFILE: 'gnb.shareprofile', // 본인뷰프로필>프로필공유
    PROFILERESET: 'gnb.profilereset', // 프로필 초기화 팝업 > 확인
    PROFILERESETGUIDE: 'gnb.profileresetguide', // 프로필 초기화 팝업 > 가이드보기
    YOURPROFILEUNBLOCK: 'gnb.yourprofileunblock', // 타인프로필>차단해제
    PC_POPUP: 'gnb.pc.popup', // PC > 인증은 모바일 환경만 가능
    MISSION: 'gnb.mission', // 미션 확인하기
    MISSION_OPEN_POPUP: 'gnb.missionopenpopup', // 미션 오픈 안내 팝업
    MISSION_OPEN_POPUP_X: 'gnb.missionopenpopupx', // 미션 오픈 안내 팝업 닫기
    MISSION_LANDING_POPUP: 'gnb.missionlandingpopup', // 미션 랜딩 팝업
    MISSION_LANDING_POPUP_X: 'gnb.missionlandingpopupx', // 미션 랜딩 팝업 닫기
    MISSION_POPUP: 'gnb.missionpopup', // 미션 팝업
    MISSION_POPUP_X: 'gnb.missionpopupx', // 미션 팝업 닫기
    PC_REVIEW_WRITE: 'gnb.pcreviewwrite', // PC>리뷰쓰기
    OTHERPROFILE: 'gnb.otherprofile', //타인프로필>사진
  },
  gnbmap: {
    NAVER: 'gnbmap.naver', // gnbmap 네이버 클릭
    PARTICIPATE: 'gnbmap.participate', // gnbmap 타인뷰 참여하기 클릭
    PLACEMY: 'gnbmap.placemy', // gnbmap 마이플레이스 클릭
    PROFILE: 'gnbmap.profile', // gnbmap 프로 클릭
    ADDMAIN: 'gnbmap.addmain', // gnbmap 메인에추가 클릭
    VISIT: 'gnbmap.visit', // gnbmap 방문내역 클릭
    SMARTORDER: 'gnbmap.smartorder', // gnbmap 네이버주문 클릭
    WARNINGGUIDE: 'gnbmap.warningguide', // gnbmap 경고팝업 가이드보기 클릭
    WARNINGCLOSE: 'gnbmap.warningclose', // gnbmap 경고팝업 닫기 클릭
    WARNING_2_GUIDE: 'gnbmap.warning2guide', // gnbmap 2차경고팝업 가이드보기 클릭
    WARNING_2_CLOSE: 'gnbmap.warning2close', // gnbmap 2차경고팝업 닫기 클릭
    WARNING_3_GUIDE: 'gnbmap.warning3guide', // gnbmap 3차경고팝업 가이드보기 클릭
    WARNING_3_CLOSE: 'gnbmap.warning3close', // gnbmap 3차경고팝업 닫기 클릭
    WARNINGPOLICY: 'gnbmap.warningpolicy', // gnbmap 경고팝업 이용정책링크
    BLACKCLOSE: 'gnbmap.blackclose', // gnbmap 블랙팝업 닫기 클릭
    BLACKGUIDE: 'gnbmap.blackguide', // gnbmap 블랙팝업 가이드보기 클릭
    BLACKPOLICY: 'gnbmap.blackpolicy', // gnbmap 블랙팝업 이용정책링크
    PCSMARTORDER: 'gnbmap.pcsmartorder', // gnbmap 네이버주문 클릭(PC)
    PCSMARTORDERPOPUP: 'gnbmap.pcsmartorderpopup', // gnbmap 네이버주문 모바일만 가능 안내 레이어 확인 클릭
    MAP: 'gnbmap.map', // gnbmap 지도 아이콘 클릭
    FOLLOW: 'gnbmap.yourprofilefol', // 타인프로필>팔로우하기
    UNFOLLOW: 'gnbmap.yourprofileunfol ', // 타인프로필>팔로잉취소
    FOLLOWREQUESTCANCEL: 'gnbmap.yourprofilefollowreqcancel', // 타인프로필>팔로우신청취소
    MYPROFILEVISIT: 'gnbmap.myprofilevisit', // 본인프로필>방문카운팅
    MYPROFILEREVIEW: 'gnbmap.myprofilereview', // 본인프로필>리뷰카운팅
    MYPROFILEFOLLOWING: 'gnbmap.myprofilefollowing', // 본인프로필>팔로잉카운팅
    MYPROFILEFOLLOWER: 'gnbmap.myprofilefollower', // 본인프로필>팔로워카운팅
    YOURPROFILEREVIEW: 'gnbmap.yourprofilereview', // 타인프로필>리뷰카운팅
    YOURPROFILEFOLLOWING: 'gnbmap.yourprofilefollowing', // 타인프로필>팔로잉카운팅
    YOURPROFILEFOLLOWER: 'gnbmap.yourprofilefollower', // 타인프로필>팔로워카운팅
    TIP: 'gnbmap.tip', // 본인뷰프로필>프로필툴팁
    MENU: 'gnbmap.menu', // 본인뷰프로필>삼선메뉴
    MYINTROMORE: 'gnbmap.myintromore', // 본인뷰프로필>소개더보기
    SHARE: 'gnbmap.share', // 본인뷰프로필>프로필공유
    INTROMORE: 'gnbmap.intromore', // 본인뷰프로필>소개더보기
    SHAREPROFILE: 'gnbmap.shareprofile', // 본인뷰프로필>프로필공유
    PROFILERESET: 'gnbmap.profilereset', // 프로필 초기화 팝업 > 확인
    PROFILERESETGUIDE: 'gnbmap.profileresetguide', // 프로필 초기화 팝업 > 가이드보기
    PC_POPUP: 'gnbmap.pc.popup', // PC > 인증은 모바일 환경만 가능,
    OTHERPROFILE: 'gnbmap.otherprofile', // 타인프로필>사진
  },
  home: {
    FOLLOW_CARD: 'home.followcard', // 팔로잉리뷰 > 개별 카드 > 리뷰
    FOLLOW_MORE: 'home.followmore', // 팔로잉리뷰 > 더보기
    FOLLOW_REVIEWER: 'home.followreviewer', // 팔로잉리뷰 > 개별 카드 > 리뷰어 프로필
    FOLLOW_SWIPE: 'home.followswipe', // 팔로잉리뷰 > 플리킹
    FOLLOW_TITLE: 'home.followtitle', // 팔로잉리뷰 > 타이틀
    BOOKMARK_TITLE: 'home.bookmarktitle', // 저장 리스트 > 타이틀
    BOOKMARK_CARD: 'home.bookmarkcard', // 저장 리스트 > 개별 카드
    BOOKMARK_SWIPE: 'home.bookmarkswipe', // 저장 리스트 > 플리킹
    BOOKMARK_MORE: 'home.bookmarkmore', // 저장 리스트 > 더보기
    GUIDE_NEXT: 'home.guidenext', // 가이드 팝업 > 다음
    GUIDE_START: 'home.guidestart', // 가이드 팝업 > 시작하기
    GUIDE_SWIPE: 'home.guideswipe', // 가이드 팝업 > 플리킹
    INTEREST_CARD_VER2: 'home.interestcardver2img', // 관심지역 리뷰 > 개별 카드 Version 2
    INTEREST_CARD: 'home.interestcard', // 관심지역 리뷰 > 개별 카드
    INTEREST_MORE: 'home.interestmore', // 관심지역 > 더보기
    INTEREST_REF: 'home.interestref', // 관심지역 > 새로고침(리뷰 더 보기)
    INTEREST_TITLE: 'home.interesttitle', // 관심지역 리뷰 > 타이틀
    MISSION_CARD: 'home.missioncard', // 미션현황 > 개별카드
    MISSION_MORE: 'home.missionmore', // 미션현황 > 더보기
    MISSION_SWIPE: 'home.missionswipe', // 미션현황 > 플리킹
    MISSION_TITLE: 'home.missiontitle', // 미션현황 > 타이틀
    ORDER_DETAIL: 'home.orderdetail', // 주문 업커밍 > 주문상세
    ORDER_MORE: 'home.ordermore', // 주문 업커밍 > 주문더보기
    ORDER_TITLE: 'home.ordertitle', // 주문 업커밍 > 타이틀
    ORDER_REFRESH: 'home.orderrefresh', // 주문 업커밍 > 새로고침
    POPULAR_ADD_INTEREST: 'home.popularaddinterest', // 인기지역 리뷰 > 관심지역 추가
    POPULAR_CARD_VER2: 'home.popularcardver2img', // 인기지역 리뷰 > 개별카드 Version 2
    POPULAR_CARD: 'home.popularcard', // 인기지역 리뷰 > 개별카드
    POPULAR_REF: 'home.popularref', // 인기지역 리뷰 > 새로고침(리뷰 더 보기)
    POPULAR_TITLE: 'home.populartitle', // 인기지역 리뷰 > 타이틀
    RESERVATION_DETAIL: 'home.reservationdetail', // 예약 업커밍 > 예약상세
    RESERVATION_MORE: 'home.reservationmore', // 예약 업커밍 > 예약더보기
    RESERVATION_TITLE: 'home.reservationtitle', // 예약 업커밍 > 타이틀
    REVIEW_CARD: 'home.reviewcard', // 인기리뷰 > 개별 카드
    REVIEW_MORE: 'home.reviewmore', // 인기리뷰 > 더보기
    REVIEW_SWIPE: 'home.reviewswipe', // 인기리뷰 > 플리킹
    REVIEW_TITLE: 'home.reviewtitle', // 인기리뷰 > 타이틀
    SHORTCUT: 'home.shortcut', // 숏컷 배너
    SURVEY: 'home.survey', // 설문참여하기 배너
    TREND_PICK: 'home.pick', // 트렌드픽 > 개별 아이콘
    TREND_PICK_SWIPE: 'home.trendpickswipe', // 트렌드픽 > 스와이프
    TREND_PICK_OMAKASE: 'home.pickomakase', // 트렌드픽 > 오마카세
    TREND_PICK_HOTEL: 'home.pickhotel', // 트렌드픽 > 호텔다이닝
    TREND_PICK_CAKE: 'home.pickcake', // 트렌드픽 > 케이크픽업
    TREND_PICK_CAMPING: 'home.pickcamping', // 트렌드픽 > 낭만캠핑
    TREND_PICK_RESORT: 'home.pickresort', // 트렌드픽 > 포근한 리조트
    TREND_PICK_SPA: 'home.pickspa', // 트렌드픽 > 뜨끈한 스파
    TREND_PICK_THEMEPARK: 'home.pickthemepark', // 트렌드픽 > 테마파크
    TREND_PICK_SHOW: 'home.pickshow', // 트렌드픽 > 공연전시
    BOOKING_BANNER: 'home.reservationbanner', // 예약 배너
    UNWRITTEN_LIST: 'home.unwrittenlist', // 미작성 리뷰 넛지 > 다른 장소 리뷰 쓰기
    UNWRITTEN: 'home.unwritten', // 미작성 리뷰 넛지 > 리뷰 쓰기
    HIDE_VISIT_WITHOUT_REVIEW: `home.visithide`, // 미작성 리뷰 넛지 > 숨김 버튼 (마지막에 index 붙여서 쓰임)
    HIDE_VISIT_WITHOUT_REVIEW_MODAL_NO: `home.visithidex`, // 미작성 리뷰 넛지 > 숨김 모달 > 취소 클릭
    HIDE_VISIT_WITHOUT_REVIEW_MODAL_YES: `home.visithideo`, // 미작성 리뷰 넛지 > 숨김 모달 > 숨기기 클릭
    VISIT_CALENDAR_NEXT: 'home.calendarnext', // 방문캘린더 > 다음달
    VISIT_CALENDAR_PREV: 'home.calendarprev', // 방문캘린더 > 이전달
    VISIT_CALENDAR_REVIEW: 'home.calendarreview', // 방문캘린더 > 리뷰 클릭
    VISIT_CALENDAR_VISIT: 'home.calendarvisit', // 방문캘린더 > 방문 클릭
    VISIT_CALENDAR_SWIPE: 'home.calendarswipe', // 방문캘린더 > 스와이프로 포커스 월 변경
    MOTIVE_TITLE: 'home.motivetitle', // 리뷰 조회수 통계 카드 타이틀 랜딩 클릭
    QUEUE_TITLE: 'home.queuetitle', // 줄서기 배너 > 타이틀
    QUEUE_DETAIL: 'home.queuedetail', // 줄서기 배너 > 상세
    QUEUE_MORE: 'home.queuemore', // 줄서기 배너 > 더보기
    QUEUE_REFRESH: 'home.queuerefresh', // 줄서기 배너 > 새로고침
    MISSION_REVIEW_SWIPE: 'home.misson2tswipe', // 미션 부스팅 카드 > 스와이프
    MISSION_REVIEW_CARD: 'home.mission2review', // 미션 부스팅 카드 > 리뷰섬네일 클릭
    MISSION_REVIEW_USER: 'home.mission2user', // 미션 부스팅 카드 > 유저프로필 클릭
    MISSION_REVIEW_CHECKIN: 'home.mission2click', // 미션 부스팅 카드 > 나도참여하기 클릭
    BANNER_VIEWER_GRAPH: 'home.bannerviewergraph', // 리뷰 영향력 카드 배너
    MOTIVE_CLICK: 'home.motiveclick', // 리뷰 영향력 카드 > 상위 랭킹 확인
  },
  lan: {
    FEED_BANNER: 'lan.mypfeedbanner1',
    FEED_TOP_BANNER: 'lan.mypfeedbanner2',
    REVIEW_END_BANNER: 'lan.reviewendbanner',
    EVENT_POPUP: 'lan.eventpopup',
    FEED_BANNER_DARK: 'lan.mypfeedbanner1dark',
    FEED_TOP_BANNER_DARK: 'lan.mypfeedbanner2dark',
    REVIEW_END_BANNER_DARK: 'lan.reviewendbannerdark',
    EVENT_POPUP_DARK: 'lan.eventpopupdark',
  },
  lnb: {
    HOME: 'lnb.home', // 홈탭
    FEED_2: 'lnb.feed2', // lnb, 피드 클릭
    VISIT: 'lnb.visit', // lnb, 방문탭 클릭
    REVIEW: 'lnb.review', // lnb, 리뷰탭 클릭
    PHOTO_REVIEW: 'lnb.photoReview', // lnb, 포토리뷰탭 클릭
    PLACE: 'lnb.place', // lnb, 장소탭 클릭
    WRITE_HOME: 'lnb.writehome', // 홈탭 리뷰 쓰기
    WRITE_VISIT: 'lnb.writevisit', // 타임라인탭 리뷰 쓰기
    WRITE_REVIEW: 'lnb.writereview', // 리뷰탭 리뷰 쓰기
    WRITE_FEED: 'lnb.writefeed', // 피드탭 리뷰 쓰기
  },
  lnbmap: {
    HOME: 'lnbmap.home',
    FEED_2: 'lnbmap.feed2', // lnbmap, 피드 클릭
    VISIT: 'lnbmap.visit', // lnbmap, 방문탭 클릭
    REVIEW: 'lnbmap.review', // lnbmap, 리뷰탭 클릭
    PHOTO_REVIEW: 'lnbmap.photoReview', // lnbmap, 포토리뷰탭 클릭
    PLACE: 'lnbmap.place', // lnbmap, 장소탭 클릭
  },
  multiMatch: {
    OUT: 'multimatch.out', // 다수매칭장소중선택, 닫기 클릭
    STOP: 'multimatch.stop', // 다수매칭장소중선택, 나가기 클릭
    SELF: 'multimatch.self', // 다수매칭장소중선택, 직접찾아보기 클릭
    SELECT: 'multimatch.select', // 다수매칭장소중선택, 장소선택 클릭
  },
  myThemeMap: {
    BACK: 'mythememap.back', // 뒤로가기
    SHARE: 'mythememap.share', // 공유하기
    OPTION: 'mythememap.option', // 옵션더보기
    EDIT: 'mythememap.edit', // 옵션_수정
    DELETE: 'mythememap.delete', // 옵션_삭제
    PRIVATE: 'mythememap.private', // 옵션_비공개로전환
    PUBLIC: 'mythememap.public', // 옵션_공개로전환
    PLACE: 'mythememap.place', // 업체 선택 - 이미지마커
    DOT_PLACE: 'mythememap.dotplace', // 업체 선택 - 점마커
    ENLARGE: 'mythememap.enlarge', // 지도 확대
    REDUCE: 'mythememap.reduce', // 지도 축소
    NOW: 'mythememap.now', // 현재 위치
    SATELLITE: 'mythememap.satellite', // 위성뷰
    REPOSITION: 'mythememap.reposition', // 원 위치로 돌아가기
    DESC: 'mythememap.desc', // 업체 상세
    SAVE: 'mythememap.save', // 저장
    UNSAVE: 'mythememap.unsave', // 저장 해제
    IMGSWIPE: 'mythememap.imgswipe', // 리뷰사진 플리킹
    DELETEOK: 'mythememap.deleteok', // 팝업_삭제하기
    DELETENO: 'mythememap.deleteno', // 팝업_삭제취소
    EDITOK: 'mythememap.editok', // 팝업_수정화면으로이동
    EDITNO: 'mythememap.editno', // 팝업_수정화면이동취소
    REACT_FIRST: 'mythememap.reactfirst', // 반응남기기(0개)
    REACT: 'mythememap.react', // 반응 남기기(1개 이상)
    HELPFUL: 'mythememap.helpful', // 리액션 선택- 도움돼요
    WANNAGO: 'mythememap.wannago', // 리액션 선택- 가고싶어요
    FUN: 'mythememap.fun', // 리액션 선택- 재밌어요
    COOL: 'mythememap.cool', // 리액션 선택- 멋져요
    REACT_LIST: 'mythememap.reactlist', // 반응한 사람 목록
    EMOJITAB: 'mythememap.emojitab', // 반응한 사람 목록 > 리액션별탭
    REACT_PROFILE: 'mythememap.reactprofile', // 반응한 사람 목록 > 프로필
    REACT_FOL: 'mythememap.reactfol', // 반응한 사람 목록 > 팔로우
    REACT_UNFOL: 'mythememap.reactunfol', // 반응한 사람 목록 > 팔로우해제
    FOLLOW: 'mythememap.follow', // 팔로우
    UNFOLLOW: 'mythememap.unfollow', // 팔로우 취소
    FOLLOWREQUESTCANCEL: 'mythememap.folreqcancel', // 팔로우 신청취소
    PHOTO: 'mythememap.photo', // 사진 썸네일 클릭
    VIDEO: 'mythememap.video', // 동영상 썸네일 클릭
    PICSWIPE: 'mythememap.picswipe', // 사진 스와이프
    TEXT: 'mythememap.text', // 텍스트 클릭
    PROFILE: 'mythememap.profile', // 프로필 클릭
  },
  myTheme: {
    BACK: 'mytheme.back', // 뒤로가기
    SHARE: 'mytheme.share', // 공유하기
    OPTION: 'mytheme.option', // 옵션더보기
    EDIT_1: 'mytheme.optionedit', // 옵션_수정
    DELETE: 'mytheme.optiondelete', // 옵션_삭제
    PRIVATE: 'mytheme.optiondraftsave', // 옵션_비공개로전환
    PUBLIC: 'mytheme.public', // 옵션_공개로전환
    PROFILE: 'mytheme.profile', // 프로필
    EDIT_2: 'mytheme.edit2', // 수정버튼
    PLACE: 'mytheme.place', // 업체상세
    TEXTMORE: 'mytheme.textmore', // 텍스트리뷰 더보기
    TEXTLESS: 'mytheme.textless', // 텍스트리뷰 접기
    SAVE: 'mytheme.save', // 저장
    UNSAVE: 'mytheme.unsave', // 저장 해제
    DELETEOK: 'mytheme.deleteok', // 팝업_삭제하기
    DELETENO: 'mytheme.deleteno', // 팝업_삭제취소
    EDITOK: 'mytheme.editok', // 팝업_수정화면으로이동
    EDITNO: 'mytheme.editno', // 팝업_수정화면이동취소
    MAP_1: 'mytheme.map1', // 상단_지도버튼
    MAP_2: 'mytheme.map2', // 스태틱_지도버튼
    REACT_FIRST: 'mytheme.reactfirst', // 반응남기기(0개)
    REACT: 'mytheme.react', // 반응 남기기(1개 이상)
    HELPFUL: 'mytheme.helpful', // 리액션 선택- 도움돼요
    WANNAGO: 'mytheme.wannago', // 리액션 선택- 가고싶어요
    FUN: 'mytheme.fun', // 리액션 선택- 재밌어요
    COOL: 'mytheme.cool', // 리액션 선택- 멋져요
    REACT_LIST: 'mytheme.reactlist', // 반응한 사람 목록
    EMOJITAB: 'mytheme.emojitab', // 반응한 사람 목록 > 리액션별탭
    REACT_PROFILE: 'mytheme.reactprofile', // 반응한 사람 목록 > 프로필
    REACT_FOL: 'mytheme.reactfol', // 반응한 사람 목록 > 팔로우
    REACT_UNFOL: 'mytheme.reactunfol', // 반응한 사람 목록 > 팔로우해제
    FOLLOW: 'mytheme.follow', // 팔로우
    UNFOLLOW: 'mytheme.unfollow', // 팔로우 취소
    FOLLOWREQUESTCANCEL: 'mytheme.folreqcancel', // 팔로우 신청취소
    PHOTO: 'mytheme.photo', // 사진 썸네일 클릭
    VIDEO: 'mytheme.video', // 동영상 썸네일 클릭
    PICSWIPE: 'mytheme.picswipe', // 사진 스와이프
    TEXT: 'mytheme.text', // 텍스트 클릭
  },
  newTheme: {
    BACK: 'newtheme.back', // 뒤로가기
    TITLE: 'newtheme.title', // 타이틀입력
    DESC: 'newtheme.desc', // 설명 입력
    COVER: 'newtheme.cover', // 커버 변경
    PUBLIC: 'newtheme.public', // 공개
    PRIVATE: 'newtheme.private', // 비공개
    ADDREVIEW: 'newtheme.addreview', // 리뷰 추가하기
    ORDER: 'newtheme.order', // 순서변경
    DELETEALL: 'newtheme.deleteall', // 전체삭제
    COMPLETE: 'newtheme.complete', // 테마등록
    DELETEOK: 'newtheme.deleteok', // 팝업_전체삭제OK
    DELETENO: 'newtheme.deleteno', // 팝업_전체삭제취소
    PRIVATEOK: 'newtheme.privateok', // 팝업_비공개로저장
    PRIVATENO: 'newtheme.privateno', // 팝업_비공개저장취소
  },
  notConnect: {
    OUT: 'notconnect.out', // 시스템오류 닫기 클릭
    BACK: 'notconnect.back', // 시스템오류 이전화면 이동
    CS: 'notconnect.cs', // 시스템오류 고객센터 클릭
    RESTART: 'notconnect.restart', // 시스템오류 다시 촬영하기 클릭
  },
  notFound: {
    OUT: 'notfound.out', // 매칭장소없음, 닫기 클릭
    AGAIN: 'notfound.again', // 매칭장소없음, 다시 촬영하기 클릭
    SELF: 'notfound.self', // 매칭장소없음, 직접찾아보기 클릭
  },
  ocrFail: {
    OUT: 'ocrfail.out', // 영수증인식실패 닫기 클릭
    RESTART: 'ocrfail.restart', // 영수증인식실패 다시 촬영하기 클릭
    CS: 'ocrfail.cs', // 영수증인식실패 도움말 클릭
  },
  own: {
    REPORT: 'own.report', // 사업자답글화면 게시중단접수방법 클릭
    SHOW_INFO: 'own.showinfo', // 영수증 인증 정보 펼치기
    HIDE_INFO: 'own.hideinfo', // 영수증 인증 정보 접기
    REPORT_REVIEW: 'own.reportreview', // 매칭 확인 신청
    REPORTGUIDE: 'own.reportguide', // 신청 안내
    CSPOPUP: 'own.cspopup', // 신청팝업_고객센터링크
    REPORTSUBMIT: 'own.reportsubmit', // 신청팝업_신청하기
    REPORTCANCEL: 'own.reportcancel', // 신청팝업_취소
    REPORTPENDING: 'own.reportpending', // 검수중 표시
    PENDINGPOPUP: 'own.pendingpopup', // 검수중팝업
    POPUP: 'own.popup', // 리뷰 답글 팁 팝업
    BANNER: 'own.banner', // 리뷰 답글 팁 배너
  },
  policy: {
    BACK: 'policy.back', // 이용정책페이지 뒤로가기 클릭
    AGREEMENT: 'policy.agreement', // 이용정책페이지 이용약관 클릭
    POLICY: 'policy.policy', // MY플레이스 이용정책(구: 이용정책) 클릭
    POLICY_ALL: 'policy.policyall', // 방문자리뷰 이용정책 클릭
  },
  receipt: {
    MAP_SUBMIT: 'receiptmap.homesubmit', // gnbmap 영수증 인증하기
    HOMESUBMIT: 'receipt.homesubmit', // gnb 영수증 인증하기
    PCSUBMIT: 'receipt.pcsubmit', // 영수증 리뷰 인증하기 클릭(PC)
    PCPOPUP: 'receipt.pcpopup', // 영수증 모바일만 가능 안내 레이어 확인 클릭
    NASUBMIT: 'receipt.nasubmit', // na에서 랜딩한 영수증 인증하기
    NACLOSE: 'receipt.naclose', // na에서 랜딩한 영수증 인증 레이어 닫기
  },
  payment: {
    THIRD_PARTY_DETAIL: 'payment.thirdpartyinfodetail', // 제3자제공동의 > 상세
    THIRD_PARTY_DISAGREE: 'payment.thirdpartydisagree', // 제3자제공동의 > 비동의
    THIRD_PARTY_AGREE: 'payment.thirdpartyagree', // 제3자제공동의 > 동의
    LIST_CARD_MANAGE: 'payment.cardmanage', // 결제내역>내자산>내카드관리
    REVIEWTARGET_FILTER_ON: 'payment.reviewtargetfilteron', // 결제내역>리뷰대상필터>대상만
    REVIEWTARGET_FILTER_OFF: 'payment.reviewtargetfilteroff', // 결제내역>리뷰대상필터>전체
    REVIEWTARGET_INFO: 'payment.reviewtargetinfo', // 결제내역>리뷰대상필터>도움말
    REVIEWTARGET_INFO_X: 'payment.reviewtargetinfox', // 	결제내역>리뷰대상필터>도움말닫기
    PAYMENT_CARDFILTER: 'payment.cardfilter', // 결제내역>카드필터
    CARDFILTER_X: 'payment.cardfilterx', // 결제내역>카드필터>나가기
    CARDFILTER_ON: 'payment.cardfilterselecton', // 결제내역>카드필터>선택
    CARDFILTER_OFF: 'payment.cardfilterselectoff', // 결제내역>카드필터>선택해제
    CARDFILTER_COMPLETE: 'payment.cardfiltercomplete', // 	결제내역>카드필터>확인
    REVIEW_WRITE: 'payment.reviewwrite', // 결제내역>리뷰쓰기
    LIST_MORE: 'payment.listmore', // 결제내역>개별>더보기
    LIST_DELETE: 'payment.listdelete', // 결제내역>개별>삭제
    LIST_DELETE_NO: 'payment.listdeleteno', // 결제내역>개별>삭제>취소
    LIST_DELETE_OK: 'payment.listdeleteok', // 결제내역>개별>삭제>삭제
    LIST_REPORT: 'payment.listreport', // 결제내역>개별>제보
    LIST_REPORT_NO: 'payment.listreportno', // 	결제내역>개별>제보>취소
    LIST_REPORT_OK: 'payment.listreportok', // 결제내역>개별>제보>제보
    LIST_LOADMORE: 'payment.listloadmore', // 결제내역>이전내역더보기
    LIST_TOTHETOP: 'payment.listtothetop', // 결제내역>맨위로
    LIST_HELP: 'payment.listhelp', // 결제내역>도움말
    LIST_HELP_CANCEL: 'payment.listhelpcancel', // 결제내역>도움말>취소
    LIST_HELP_CARD_LINK: 'payment.listhelpcardlink', // 결제내역>도움말>내자산카드연결
    CARD_LOAD: 'payment.cardload', // 결제내역>카드불러오기배너
    CARD_FILTER_CONNECRT: 'payment.cardfilterconnect', // 결제내역>카드필터>내자산연결
    PAY_FILTER_SELECT_ON: 'payment.payfilterselecton', // 결제내역>현장결제활성화
    PAY_FILTER_SELECT_OFF: 'payment.payfilterselectoff', // 결제내역>현장결제비활성화
  },
  reviewEdit: {
    OUT: 'reviewedit.out', // 리뷰수정, 뒤로가기 클릭
    OUT2: 'reviewedit.out2', // 리뷰수정, 2단계 상단 X로 나가기
    TEXT: 'reviewedit.text', // 리뷰수정, 텍스트 클릭
    PHOTO: 'reviewedit.photo', // 리뷰수정, 사진추가 클릭
    PHOTODELETE: 'reviewedit.photodelete', // 리뷰수정, 사진삭제 클릭
    TIP: 'reviewedit.tip', // 리뷰수정, 작성유의사항 클릭
    COMPLETE: 'reviewedit.complete', // 리뷰수정, 작성완료 클릭
    SELECT: 'reviewedit.select', // 리뷰수정, 대표사진선택 클릭
    UNSELECT: 'reviewedit.unselect', // 리뷰수정, 대표사진해제 클릭
    PHOTONO: 'reviewedit.photono', // 리뷰수정, 사진삭제 클릭
    ADD: 'reviewedit.add', // 리뷰수정, 사진추가 클릭
    STAR: 'reviewedit.star', // 리뷰수정, 별점 클릭
    POPUPOK: 'reviewedit.popupok', // 리뷰수정, 유의사항 확인 클릭
    OUTYES: 'reviewedit.outyes', // 리뷰수정, 팝업_나가기 확인 클릭
    OUTNO: 'reviewedit.outno', // 리뷰수정, 팝업_나가기 취소 클릭
    OUTYES2: 'reviewedit.outyes2', // 리뷰쓰기, 2단계 X 팝업_나가기YES
    OUTNO2: 'reviewwedit.outno2', // 리뷰쓰기, 2단계 X 팝업_나가기NO
    LIKE: 'reviewedit.like', // 리뷰수정, 좋아요 클릭
    UNLIKE: 'reviewedit.unlike', // 리뷰수정, 좋아요 취소 클릭
    OPENLIKEPOPUP: 'reviewedit.likepopup', // 리뷰쓰기, 좋아요 팝업 열기
    CLOSELIKEPOPUP: 'reviewedit.likepopupx', // 리뷰쓰기, 좋아요 팝업 닫기
    OPENKEYWORDPOPUP: 'reviewedit.kwpopup', // 리뷰쓰기, 키워드 팝업 열기
    CLOSEKEYWORDPOPUP: 'reviewedit.kwpopupx', // 리뷰쓰기, 키워드 팝업 닫기
    OPENSTARPOPUP: 'reviewedit.starpopup', // 리뷰쓰기, 별점종료 팝업 열기
    CLOSESTARPOPUP: 'reviewedit.starpopupx', // 리뷰쓰기, 별점종료 팝업 닫기
    SELECTKEYWORD: 'reviewedit.keyword', // 리뷰쓰기, 별점종료 팝업 열기
    UNSELECTKEYWORD: 'reviewedit.keywordx', // 리뷰쓰기, 별점종료 팝업 닫기
    NOKEYWORD: 'reviewedit.nokeyword', // 선택할 키워드가 없어요 버튼선택
    NOKEYWORDX: 'reviewedit.nokeywordx', // 선택할 키워드가 없어요 버튼해제
    STARXX: 'reviewedit.starxx', // 딤드된 별 선택
    POVCARD: 'reviewedit.povcard', // pov 카드 선택
    MISSION_POP_X: 'reviewedit.missionpopx', // 미션참여알럿>다음에
    MISSION_POP_O: 'reviewedit.missionpopo', // 미션참여알럿>작성할게요
    MORE: 'reviewedit.more', // 첫번째 펼치기
    MORE_TWICE: 'reviewedit.moretwice', // 두번째 펼치기
    LESS: 'reviewedit.less', // 접기
    ITEM_MORE: 'reviewedit.itemmore', // 상품명 추가 펼치기
    ITEM_LESS: 'reviewedit.itemless', // 상품명 추가 펼치기 상태 접기
    MORE_KEYWORD: 'reviewedit.morekeyword', // 펼친 키워드
    MORE_KEYWORDX: 'reviewedit.morekeywordx', // 펼친 키워드 해제
    CLEANBOTX: 'reviewedit.cleanbotx', // 클린봇 팝업 취소 버튼
    CLEANBOTO: 'reviewedit.cleanboto', // 클린봇 팝업 등록 버튼
    RESERVEBTN: 'reviewedit.reservebtn', // 예약/대기문항 유도 버튼
    KEYWORD_OPEN: 'reviewedit.keywordopen', // 키워드 펼치기
    BACK: 'reviewedit.back', // 이전
    NEXT: 'reviewwedit.next', // 1단계 > 다음
    NAVERPOPUPYES: 'reviewedit.naverpoppupyes', // 네이버열기팝업_YES
    NAVERPOPUPNO: 'reviewedit.naverpoppupno', // 네이버열기팝업_YNO
    VISIT_QUESTION: 'reviewedit.visitquestion', //방문문항 선택
    VISIT_QUESTIONX: 'reviewedit.visitquestionx', //방문문항 해제
    STAR1: 'reviewedit.star1', // 별점 1점
    STAR2: 'reviewedit.star2', // 별점 2점
    STAR3: 'reviewedit.star3', // 별점 3점
    STAR4: 'reviewedit.star4', // 별점 4점
    STAR5: 'reviewedit.star5', // 별점 5점
  },
  reviewEndOthers: {
    PROFILE: 'reviewendothers.profile', // 이 장소의 다른 리뷰 > 프로필 클릭
    VIEWMORE: 'reviewendothers.viewmore', // 이 장소의 다른 리뷰 > 더보기 클릭
    SHARE: 'reviewendothers.share', // 이 장소의 다른 리뷰 > 더보기 클릭
    PERVIOUS: 'reviewendothers.pervious', // 이 장소의 다른 리뷰 > 이전사진 플리킹
    NEXT: 'reviewendothers.next', // 이 장소의 다른 리뷰 > 다음사진 플리킹
    CHANGELIST: 'reviewendothers.changelist', // 이 장소의 다른 리뷰 > 장소저장 후 변경하기 클릭
    PICSWIPE: 'reviewendothers.picswipe', // 이 장소의 다른 리뷰 > 사진스와이프
    ONLYRATINGOPEN: 'reviewend.onlyratingopen', // 리뷰 엔드 별점 영역 열기
    ONLYRATINGCLOSE: 'reviewend.onlyratingclose', // 리뷰 엔드 별점 영역 닫기
    FOLLOW: 'reviewendothers.followingfol', // 이 장소의 다른 리뷰 > 팔로우하기
    UNFOLLOW: 'reviewendothers.followingunfol', // 이 장소의 다른 리뷰 > 팔로잉취소
    FOLLOWREQUESTCANCEL: 'reviewendothers.followingreqcancel', // 이 장소의 다른 리뷰 > 팔로우신청취소
    FULLKEYWORD: 'reviewendothers.fullkeyword', // 리뷰 엔드 이 장소 다른 리뷰, 키워드 펼침
    PHOTO: 'reviewendothers.photo', // 이 장소의 다른 리뷰 > 사진 썸네일 클릭
    VIDEO: 'reviewendothers.video', // 이 장소의 다른 리뷰 > 동영상 썸네일 클릭
    SORTBEST: 'reviewendothers.sortbest', // 이 장소의 다른 리뷰 > 추천순
    SORTRECENT: 'reviewendothers.sortrecent', // 이 장소의 다른 리뷰 > 최신순
    SORTINFO: 'reviewendothers.sortinfo', // 이 장소의 다른 리뷰 > 정렬툴팁 보기
    CLOSESORTINFO: 'reviewendothers.closesortinfo', // 이 장소의 다른 리뷰 > 정렬툴팁 닫기
    VIEWVISIT: 'reviewendothers.viewvisit', // 이 장소의 다른 리뷰 > 방문 기록 보기
    BLOCK: 'reviewendothers.block', // 이 장소의 다른 리뷰 > 더보기 > 리뷰어 차단
    TEXT: 'reviewendothers.text', // 이 장소의 다른 리뷰 > 텍스트 클릭
  },
  reviewEnd: {
    BACK: 'reviewend.back', // 리뷰엔드, 뒤로가기 클릭
    PROFILE: 'reviewend.profile', // 리뷰엔드, 프로필 클릭
    VIEWMORE: 'reviewend.viewmore', // 메인 리뷰 > 더보기
    REPORT: 'reviewend.report', // 메인 리뷰 > 더보기 > 리뷰/리뷰어 신고
    PLACE: 'reviewend.place', // 리뷰엔드, 장소명 클릭
    SAVE: 'reviewend.save', // 리뷰엔드, 장소저장 클릭
    UNSAVE: 'reviewend.unsave', // 리뷰엔드, 장소저장취소 클릭
    SHARE: 'reviewend.share', // 리뷰엔드, 공유 클릭
    DELETE: 'reviewend.delete', // 리뷰엔드 삭제하기 클릭
    EDIT: 'reviewend.edit', // 리뷰엔드 수정하기 클릭
    DELETENO: 'reviewend.deleteno', // 리뷰엔드 리뷰삭제모달 취소 클릭
    DELETEYES: 'reviewend.deleteyes', // 리뷰엔드 리뷰삭제모달 확인 클릭
    PICSWIPE: 'reviewend.picswipe', // 리뷰엔드 사진스와이프
    EDITMORE: 'reviewend.editmore', // 리뷰 엔드 방문 경험을 남겨주세요
    HIDEGUIDE: 'reviewend.hideguide', // 미노출 처리 리뷰 엔드페이지 안내 문구 더보기
    REPORTGUIDE: 'reviewend.reportguide', // 미노출 처리 리뷰 엔드페이지 안내 문구 더보기
    FOLLOW: 'reviewend.followingfol', // 리뷰 엔드 팔로우하기
    UNFOLLOW: 'reviewend.followingunfol', // 리뷰 엔드 팔로잉취소
    FOLLOWREQUESTCANCEL: 'reviewend.followingreqcancel', // 리뷰 엔드 팔로우신청취소
    PLACEMY: 'reviewend.placemy', // MY플레이스 홈 클릭
    KEYWORDMORE: 'reviewend.keywordmore', // 리뷰엔드 키워드 +숫자
    KEYWORDLESS: 'reviewend.keywordless', // 리뷰엔드 키워드 접기
    MISSION: 'reviewend.mission', // 리뷰엔드 미션 모달 > 미션 보러가기
    MISSIONX: 'reviewend.missionx', // 리뷰엔드 미션 모달 > 닫기
    MISSION_RESERVPOP: 'reviewend.missionreservpop', // 미션예약/주문팝업>미션보러가기
    MISSION_RESERVPOPX: 'reviewend.missionreservpopx', // 미션예약/주문팝업>닫기
    PHOTO: 'reviewend.photo', // 사진 썸네일 클릭
    VIDEO: 'reviewend.video', // 동영상 썸네일 클릭,
    REACT_FIRST: 'reviewend.reactfirst', // 반응남기기(0개)
    REACT: 'reviewend.react', // 반응 남기기(1개 이상)
    HELPFUL: 'reviewend.helpful', // 리액션 선택- 도움돼요
    WANNAGO: 'reviewend.wannago', // 리액션 선택- 가고싶어요
    FUN: 'reviewend.fun', // 리액션 선택- 재밌어요
    COOL: 'reviewend.cool', // 리액션 선택- 멋져요
    REACT_LIST: 'reviewend.reactlist', // 반응한 사람 목록
    EMOJITAB: 'reviewend.emojitab', // 반응한 사람 목록 > 리액션별탭
    REACT_PROFILE: 'reviewend.reactprofile', // 반응한 사람 목록 > 프로필
    REACT_FOL: 'reviewend.reactfol', // 반응한 사람 목록 > 팔로우
    REACT_UNFOL: 'reviewend.reactunfol', // 반응한 사람 목록 > 팔로우해제
    VISIT_KEYWORD_MORE: 'reviewend.visitqmore', // 방문 키워드 펼치기
    VIEWVISIT: 'reviewend.viewvisit', // 메인 리뷰 > 더보기 > 방문 기록 보기
    BLOCK: 'reviewend.block', // 메인 리뷰 > 더보기 > 리뷰어 차단
    TEXT: 'reviewend.text', // 메인 리뷰 > 텍스트 클릭
  },
  reviewReply: {
    BACK: 'own.back', // 리뷰 답글 뒤로가기
    TEXT: 'own.text', // 리뷰 답글 텍스트 영역
    SUBMIT: 'own.submit', // 리뷰 답글 등록
    DELETE: 'own.delete', // 리뷰 답글 삭제
  },
  reviewTabOthers: {
    ALL: 'otherreviewtab.all', // 리뷰탭, 전체리뷰
    PHOTO: 'otherreviewtab.photo', // 리뷰탭, 사진리뷰
    CATEGORYALL: 'otherreviewtab.categoryall', // 업종탭, 전체
    CATEGORYRES: 'otherreviewtab.categoryres', // 업종탭, 음식점
    CATEGORYACC: 'otherreviewtab.categoryacc', // 업종탭, 숙박
    CATEGORYATT: 'otherreviewtab.categoryatt', // 업종탭, 여행명소
    CATEGORYBEA: 'otherreviewtab.categorybea', // 업종탭, 뷰티
    CATEGORYEXT: 'otherreviewtab.categoryext', // 업종탭, 기타
    CATEGORYRESALL: 'otherreviewtab.categoryresall', // 업종탭, 음식점, 전체
    CATEGORYRESKR: 'otherreviewtab.categoryreskr', // 업종탭, 음식점, 한식
    CATEGORYRESWT: 'otherreviewtab.categoryreswt', // 업종탭, 음식점, 양식
    CATEGORYRESCH: 'otherreviewtab.categoryresch', // 업종탭, 음식점, 중식
    CATEGORYRESJP: 'otherreviewtab.categoryresjp', // 업종탭, 음식점, 일식
    CATEGORYRESAF: 'otherreviewtab.categoryresaf', // 업종탭, 음식점, 아시아퓨전
    CATEGORYRESCD: 'otherreviewtab.categoryrescd', // 업종탭, 음식점, 카페디저트
    CATEGORYRESSC: 'otherreviewtab.categoryressc', // 업종탭, 음식점, 분식치킨
    CATEGORYRESBA: 'otherreviewtab.categoryresba', // 업종탭, 음식점, 술집
    CATEGORYRESBF: 'otherreviewtab.categoryresbf', // 업종탭, 음식점, 뷔페기타
    ALIGN: 'otherreviewtab.align', // 리뷰탭, 정렬
    ALIGNOUT: 'otherreviewtab.alignout', // 리뷰탭, 정렬 나가기
    NEW: 'otherreviewtab.new', // 리뷰탭, 최신순
    VIEW: 'otherreviewtab.view', // 리뷰탭, 조회수순
    VIEWINFO: 'otherreviewtab.viewinfo', // 리뷰탭, 조회수안내
    REVIEW: 'otherreviewtab.review', // 리뷰탭, 리뷰카드 클릭
    THEMELIST: 'otherreviewtab.themelist', // 리뷰탭, 타인의테마선택
    SAVE: 'otherreviewtab.save', // 리뷰탭, 리스트 장소 저장 클릭
    UNSAVE: 'otherreviewtab.unsave', // 리뷰탭, 리스트 장소 저장 취소 클릭
    MEDIARV: 'otherreviewtab.mediarv', // 사진/영상 리뷰 썸네일 선택
    NOMEDIARV: 'otherreviewtab.nomediarv', // 사진/영상 없는 리뷰 썸네일 선택
    FILTERALL: 'otherreviewtab.filterall', // 전체 업종필터
    FILTERMENU: 'otherreviewtab.filtermenu', // 메뉴 업종필터
    FILTERCATEGORY: 'otherreviewtab.filtercategory', // 메인 업종필터
    FILTERTOOLTIPX: 'otherreviewtab.filtertooltipx', // 툴팁 닫기
    FILTERDONG: 'otherreviewtab.filterdong', // 읍면동 지역필터
    FILTERSIGUNGU: 'otherreviewtab.filtersigungu', // 시군구 지역필터
  },
  reviewTab: {
    ALL: 'reviewtab.all', // 리뷰탭, 전체리뷰
    PHOTO: 'reviewtab.photo', // 리뷰탭, 사진리뷰
    ALIGN: 'reviewtab.align', // 리뷰탭, 정렬
    ALIGNOUT: 'reviewtab.alignout', // 리뷰탭, 정렬 나가기
    NEW: 'reviewtab.new', // 리뷰탭, 최신순
    VIEW: 'reviewtab.view', // 리뷰탭, 조회수순
    RATINGHIGH: 'reviewtab.ratinghigh', // 리뷰탭, 평점높은순
    RATINGLOW: 'reviewtab.ratinglow', // 리뷰탭, 평점낮은순
    VIEWINFO: 'reviewtab.viewinfo', // 리뷰탭, 조회수안내
    REVIEW: 'reviewtab.review', // 리뷰탭, 리뷰카드 클릭
    NEWTHEME_1: 'reviewtab.newtheme1', // 리뷰탭, 테마만들기 큰버튼
    NEWTHEME_2: 'reviewtab.newtheme2', // 리뷰탭, 리뷰카드 클릭
    MYTHEME: 'reviewtab.mytheme', // 리뷰탭, 내테마선택
    SAVE: 'reviewtab.save', // 리뷰탭, 리스트 장소 저장 클릭
    UNSAVE: 'reviewtab.unsave', // 리뷰탭, 리스트 장소 저장 취소 클릭
    MEDIARV: 'reviewtab.mediarv', // 사진/영상 리뷰 썸네일 선택
    NOMEDIARV: 'reviewtab.nomediarv', // 사진/영상 없는 리뷰 썸네일 선택
    FILTERALL: 'reviewtab.filterall', // 전체 업종필터
    FILTERMENU: 'reviewtab.filtermenu', // 메뉴 업종필터
    FILTERCATEGORY: 'reviewtab.filtercategory', // 메인 업종필터
    FILTERTOOLTIPX: 'reviewtab.filtertooltipx', // 툴팁 닫기
    FILTERDONG: 'reviewtab.filterdong', // 읍면동 지역필터
    FILTERSIGUNGU: 'reviewtab.filtersigungu', // 시군구 지역필터
    CLIP_FIRST: 'reviewtab.clipfirst', // 리뷰탭 > 클립 최초팝업
    CLIP: 'reviewtab.clip', // 리뷰탭 > 클립 에디터
    CLIP_THUMB: 'reviewtab.clipthumb', // 리뷰탭 > 클립 썸네일
    CLIP_EDIT: 'reviewtab.clipedit', // 리뷰탭 > 클립 수정
    CLIP_DEL: 'reviewtab.clipdel', // 리뷰탭 > 클립 삭제
    CLIP_DEL_X: 'reviewtab.clipdelx', // 리뷰탭 > 클립 삭제 팝업 취소
    CLIP_DEL_O: 'reviewtab.clipdelo', // 리뷰탭 > 클립 삭제 팝업 삭제
  },
  reviewWrite: {
    OUT: 'reviewwrite.out', // 리뷰쓰기, 뒤로가기 클릭
    OUT2: 'reviewwrite.out2', // 리뷰쓰기, 2단계 상단 X로 나가기
    TEXT: 'reviewwrite.text', // 리뷰쓰기, 텍스트 클릭
    PHOTO: 'reviewwrite.photo', // 리뷰쓰기, 사진추가 클릭
    PHOTODELETE: 'reviewwrite.photodelete', // 리뷰쓰기, 사진삭제 클릭
    TIP: 'reviewwrite.tip', // 리뷰쓰기, 작성유의사항 클릭
    COMPLETE: 'reviewwrite.complete', // 리뷰쓰기, 작성완료 클릭
    SELECT: 'reviewwrite.select', // 리뷰쓰기, 대표사진선택 클릭
    UNSELECT: 'reviewwrite.unselect', // 리뷰쓰기, 대표사진해제 클릭
    PHOTONO: 'reviewwrite.photono', // 리뷰쓰기, 사진삭제 클릭
    ADD: 'reviewwrite.add', // 리뷰쓰기, 사진추가 클릭
    STAR: 'reviewwrite.star', // 리뷰쓰기, 별점 클릭
    POPUPOK: 'reviewwrite.popupok', // 리뷰쓰기, 유의사항 확인 클릭
    OUTYES: 'reviewwrite.outyes', // 리뷰쓰기, 팝업_나가기 확인 클릭
    OUTNO: 'reviewwrite.outno', // 리뷰쓰기, 팝업_나가기 취소 클릭
    OUTYES2: 'reviewwrite.outyes2', // 리뷰쓰기, 2단계 X 팝업_나가기YES
    OUTNO2: 'reviewwrite.outno2', // 리뷰쓰기, 2단계 X 팝업_나가기NO
    LIKE: 'reviewwrite.like', // 리뷰쓰기, 좋아요 클릭
    UNLIKE: 'reviewwrite.unlike', // 리뷰쓰기, 좋아요 취소 클릭
    OPENLIKEPOPUP: 'reviewwrite.likepopup', // 리뷰쓰기, 좋아요 팝업 열기
    CLOSELIKEPOPUP: 'reviewwrite.likepopupx', // 리뷰쓰기, 좋아요 팝업 닫기
    OPENKEYWORDPOPUP: 'reviewwrite.kwpopup', // 리뷰쓰기, 키워드 팝업 열기
    CLOSEKEYWORDPOPUP: 'reviewwrite.kwpopupx', // 리뷰쓰기, 키워드 팝업 닫기
    OPENSTARPOPUP: 'reviewwrite.starpopup', // 리뷰쓰기, 별점종료 팝업 열기
    CLOSESTARPOPUP: 'reviewwrite.starpopupx', // 리뷰쓰기, 별점종료 팝업 닫기
    SELECTKEYWORD: 'reviewwrite.keyword', // 리뷰쓰기, 별점종료 팝업 열기
    UNSELECTKEYWORD: 'reviewwrite.keywordx', // 리뷰쓰기, 별점종료 팝업 닫기
    NOKEYWORD: 'reviewwrite.nokeyword', // 선택할 키워드가 없어요 버튼선택
    NOKEYWORDX: 'reviewwrite.nokeywordx', // 선택할 키워드가 없어요 버튼해제
    STARXX: 'reviewwrite.starxx', // 딤드된 별 선택
    POVCARD: 'reviewwrite.povcard', // pov 카드 선택
    MISSION_POP_X: 'reviewwrite.missionpopx', // 미션참여알럿>다음에
    MISSION_POP_O: 'reviewwrite.missionpopo', // 미션참여알럿>작성할게요
    MORE: 'reviewwrite.more', // 첫번째 펼치기
    MORE_TWICE: 'reviewwrite.moretwice', // 두번째 펼치기
    LESS: 'reviewwrite.less', // 접기
    ITEM_MORE: 'reviewwrite.itemmore', // 상품명 추가 펼치기
    ITEM_LESS: 'reviewwrite.itemless', // 상품명 추가 펼치기 상태 접기
    MORE_KEYWORD: 'reviewwrite.morekeyword', // 펼친 키워드
    MORE_KEYWORDX: 'reviewwrite.morekeywordx', // 펼친 키워드 해제
    DRAFTNO: 'reviewwrite.draftno', // 임시저장 팝업_불러오기NO
    DRAFTYES: 'reviewwrite.draftyes', //임시저장 팝업_불러오기YES
    HOME_SUBMIT: 'reviewwrite.homesubmit', // 홈>리뷰쓰기인증
    CLEANBOTX: 'reviewwrite.cleanbotx', // 클린봇 팝업 취소 버튼
    CLEANBOTO: 'reviewwrite.cleanboto', // 클린봇 팝업 등록 버튼
    RESERVEBTN: 'reviewwrite.reservebtn', // 예약/대기문항 유도 버튼
    KEYWORD_OPEN: 'reviewwrite.keywordopen', // 키워드 펼치기
    BACK: 'reviewwrite.back', // 이전
    NEXT: 'reviewwrite.next', // 1단계 > 다음
    NAVERPOPUPYES: 'reviewwrite.naverpoppupyes', // 네이버열기팝업_YES
    NAVERPOPUPNO: 'reviewwrite.naverpoppupno', // 네이버열기팝업_YNO
    VISIT_QUESTION: 'reviewwrite.visitquestion', //방문문항 선택
    VISIT_QUESTIONX: 'reviewwrite.visitquestionx', //방문문항 해제
    STAR1: 'reviewwrite.star1', // 별점 1점
    STAR2: 'reviewwrite.star2', // 별점 2점
    STAR3: 'reviewwrite.star3', // 별점 3점
    STAR4: 'reviewwrite.star4', // 별점 4점
    STAR5: 'reviewwrite.star5', // 별점 5점
  },
  // 리작완: @see https://wiki.navercorp.com/pages/viewpage.action?pageId=1661159519
  reviewComplete: {
    CLOSE: 'reviewdone.close', // 상단 > 닫기버튼
    MISSION_BANNER: 'reviewdone.missiondone', // 미션 > 당첨배너
    MISSION_STAMP_FLICK: 'reviewdone.missionswipe', // 미션 > 스탬프 카드 플리킹
    MISSION_MORE: 'reviewdone.missionmore', // 미션 > 더보기
    REVIEW_WITH_STAT: 'reviewdone.reviewfeed1', // 작성한 리뷰 미리보기 > 통계값 있는 카드
    REVIEW_NON_PAID: 'reviewdone.reviewfeed2', // 작성한 리뷰 미리보기 > 무결제 허용(cid 아님) 카드
    REVIEW_NON_PAID_VISIT: 'reviewdone.reviewfeed2visit', // 작성한 리뷰 미리보기 > 무결제 허용(cid 아님) 카드 위 방문인증하기 버튼
    REVIEW_WITHOUT_STAT: 'reviewdone.reviewfeed3', // 작성한 리뷰 미리보기 > 그 외 통계값 없는 카드
    OTHER_REVIEW: 'reviewdone.otherreviewcard', // 다른 방문자 리뷰 > 카드
    OTHER_REVIEW_FLICK: 'reviewdone.otherreviewswipe', // 다른 방문자 리뷰 > 카드 플리킹
    OTHER_REVIEW_MORE: 'reviewdone.otherreviewmore', // 다른 방문자 리뷰 > 더보기
    RECOMMEND_PLACE_NON_FEED_REGION: 'reviewdone.otherspot1img', // 장소 추천 > 관심지역 설정 안 된 지역의 카드
    RECOMMEND_PLACE_NON_FEED_REGION_REFRESH: 'reviewdone.otherspot1ref', // 장소 추천 > 관심지역 설정 된 지역의 카드
    RECOMMEND_PLACE_FEED_REGION: 'reviewdone.otherspot2img', // 장소 추천 > 관심지역 설정 된 지역의 카드
    RECOMMEND_PLACE_FEED_REGION_REFRESH: 'reviewdone.otherspot2ref', // 장소 추천 > 관심지역 설정 된 지역의 카드
    RECOMMEND_PLACE_ADD_FEED_REGION: 'reviewdone.otherspotaddinterest', // 장소 추천 > 관심지역 추가
    RECOMMEND_PLACE_REVIEW_MORE: 'reviewdone.otherspotmore', // 장소 추천 > 리뷰 더보기 카드
    REVIEW_WRITE_CONTINUE: 'reviewdone.reviewwrite1', // 리뷰이어쓰기
    SURVEY_BANNER: 'reviewdone.survey', // 설문 배너
    MY_REVIEW: 'reviewdone.reviewfeedbutton', // 내가 쓴 리뷰 보러가기
    SCROLL: 'reviewdone.scroll', // 스크롤 내리기
    PICSWIPE: 'reviewdone.reviewfeedpicswipe', // 내 리뷰 사진스와이프
    UNWRITTEN: 'reviewdone.unwritten', // 미작성 리뷰 넛지 > 리뷰 쓰기
    HIDE_VISIT_WITHOUT_REVIEW: `reviewdone.visithide`, // 미작성 리뷰 넛지 > 숨김 버튼 (마지막에 index 붙여서 쓰임)
    HIDE_VISIT_WITHOUT_REVIEW_MODAL_NO: `reviewdone.visithidex`, // 미작성 리뷰 넛지 > 숨김 모달 > 취소 클릭
    HIDE_VISIT_WITHOUT_REVIEW_MODAL_YES: `reviewdone.visithideo`, // 미작성 리뷰 넛지 > 숨김 모달 > 숨기기 클릭
    UNWRITTEN_LIST: 'reviewdone.unwrittenlist', // 미작성 리뷰 넛지 > 다른 장소 리뷰 쓰기
    REVIEW_WRITE_UP: 'reviewdone.reviewwriteup', // 미션 카드 > 이어서 리뷰 더 쓰기
  },
  sameReceipt: {
    OUT: 'samereceipt.out', // 인증결과 > 동일영수증, X 나가기 버튼 클릭
    CS: 'samereceipt.cs', // 인증결과 > 동일영수증, 고객센터 버튼 클릭
    GOREVIEW: 'samereceipt.goreview', // 인증결과 > 동일영수증, 리뷰로 이동 클릭
  },
  selfSearch: {
    BACK: 'selfsearch.back', // 장소직접검색, 뒤로가기 클릭
    TEXT: 'selfsearch.text', // 장소직접검색, 텍스트입력창 클릭
    SEARCH: 'selfsearch.search', // 장소직접검색, 검색 클릭
    SELECT: 'selfsearch.select', // 장소직접검색, 장소선택 클릭
    ADD: 'selfsearch.add', // 장소직접검색, 신규장소등록 클릭
  },
  tagSetting: {
    BACK: 'tagsetting.close', // 팔로잉 태그 관리>페이지 닫기
    LISTORDER: 'tagsetting.listorder', // 팔로잉 태그 관리>태그 순서변경
    LISTDELETE: 'tagsetting.listdelete', // 팔로잉 태그 관리>태그 팔로우 취소
    LISTDELCANCEL: 'tagsetting.listdelcancel', // 태그 팔로우 취소 안내 팝업>팔로우 취소 아니요
    LISTDELYES: 'tagsetting.listdelyes', // 태그 팔로우 취소 안내 팝업>팔로우 취소
    SAVE: 'tagsetting.save', // 팔로잉 태그 관리>이대로 저장할래요
    BACKCANCEL: 'tagsetting.backcancel', // 나가기 안내 팝업>나가기 취소
    BACKYES: 'tagsetting.backyes', // 나가기 안내 팝업>저장하지 않고 나가기
  },
  themeCover: {
    BACK: 'themecover.back', // 뒤로가기
    ADDPIC: 'themecover.addpic', // 사진추가
    SELECT: 'themecover.select', // 커버선택
    COMPLETE: 'themecover.complete', // 완료
  },
  themeListMap: {
    BACK: 'themelistmap.back', // 뒤로가기
    SHARE: 'themelistmap.share', // 공유하기
    PLACE: 'themelistmap.place', // 업체 이미지마커
    DOT_PLACE: 'themelistmap.dotplace', // 업체 점마커
    ENLARGE: 'themelistmap.enlarge', // 지도 확대
    REDUCE: 'themelistmap.reduce', // 지도 축소
    NOW: 'themelistmap.now', // 현재 위치
    SATELLITE: 'themelistmap.satellite', // 위성뷰
    REPOSITION: 'themelistmap.reposition', // 원 위치로 돌아가기
    DESC: 'themelistmap.desc', // 업체 상세
    SAVE: 'themelistmap.save', // 저장
    UNSAVE: 'themelistmap.unsave', // 저장 해제
    IMGSWIPE: 'themelistmap.imgswipe', // 리뷰사진 플리킹
    REACT_FIRST: 'themelistmap.reactfirst', // 반응남기기(0개)
    REACT: 'themelistmap.react', // 반응 남기기(1개 이상)
    HELPFUL: 'themelistmap.helpful', // 리액션 선택- 도움돼요
    WANNAGO: 'themelistmap.wannago', // 리액션 선택- 가고싶어요
    FUN: 'themelistmap.fun', // 리액션 선택- 재밌어요
    COOL: 'themelistmap.cool', // 리액션 선택- 멋져요
    REACT_LIST: 'themelistmap.reactlist', // 반응한 사람 목록
    EMOJITAB: 'themelistmap.emojitab', // 반응한 사람 목록 > 리액션별탭
    REACT_PROFILE: 'themelistmap.reactprofile', // 반응한 사람 목록 > 프로필
    REACT_FOL: 'themelistmap.reactfol', // 반응한 사람 목록 > 팔로우
    REACT_UNFOL: 'themelistmap.reactunfol', // 반응한 사람 목록 > 팔로우해제
    FOLLOW: 'themelistmap.follow', // 팔로우
    UNFOLLOW: 'themelistmap.unfollow', // 팔로우 취소
    FOLLOWREQUESTCANCEL: 'themelistmap.folreqcancel', // 팔로우 신청취소
    PHOTO: 'themelistmap.photo', // 사진 썸네일 클릭
    VIDEO: 'themelistmap.video', // 동영상 썸네일 클릭
    PICSWIPE: 'themelistmap.picswipe', // 사진 스와이프
    TEXT: 'themelistmap.text', // 텍스트 클릭
    PROFILE: 'themelistmap.profile', // 프로필 클릭
  },
  themeList: {
    BACK: 'themelist.back', // 뒤로가기
    MAP_1: 'themelist.map1', // 상단_지도버튼
    MAP_2: 'themelist.map2', // 스태틱_지도버튼
    SHARE: 'themelist.share', // 공유하기
    PROFILE: 'themelist.profile', // 프로필
    PLACE: 'themelist.place', // 업체상세
    TEXTMORE: 'themelist.textmore', // 텍스트리뷰 더보기
    TEXTLESS: 'themelist.textless', // 텍스트리뷰 접기
    SAVE: 'themelist.save', // 저장
    UNSAVE: 'themelist.unsave', // 저장 해제
    PHOTO: 'themelist.photo', // 사진 썸네일 클릭
    VIDEO: 'themelist.video', // 동영상 썸네일 클릭
    REACT_FIRST: 'themelist.reactfirst', // 반응남기기(0개)
    REACT: 'themelist.react', // 반응 남기기(1개 이상)
    HELPFUL: 'themelist.helpful', // 리액션 선택- 도움돼요
    WANNAGO: 'themelist.wannago', // 리액션 선택- 가고싶어요
    FUN: 'themelist.fun', // 리액션 선택- 재밌어요
    COOL: 'themelist.cool', // 리액션 선택- 멋져요
    REACT_LIST: 'themelist.reactlist', // 반응한 사람 목록
    EMOJITAB: 'themelist.emojitab', // 반응한 사람 목록 > 리액션별탭
    REACT_PROFILE: 'themelist.reactprofile', // 반응한 사람 목록 > 프로필
    REACT_FOL: 'themelist.reactfol', // 반응한 사람 목록 > 팔로우
    REACT_UNFOL: 'themelist.reactunfol', // 반응한 사람 목록 > 팔로우해제
    REVIEWER_PROFILE: 'themelist.reviewerprofile', // 리뷰어 프로필
    REVIEWER_FOLLOWING: 'themelist.reviewerfol', // 리뷰어 > 팔로우하기
    REVIEWER_UNFOLLOWING: 'themelist.reviewerunfol', // 리뷰어>팔로우취소
    REVIEWER_REQUEST_CANCEL: 'themelist.reviewerreqcancel', // 리뷰어>팔로우신청취소
    TEXT: 'themelist.text', // 리뷰 텍스트
    PICSWIPE: 'themelist.photoswipe', // 사진 스와이프,
    PLACEMY: 'themelist.placemy', // 테마리스트>마플홈
    FOLLOW: 'themelist.follow', // 팔로우
    UNFOLLOW: 'themelist.unfollow', // 팔로우 취소
    FOLLOWREQUESTCANCEL: 'themelist.folreqcancel', // 팔로우 신청취소
  },
  themeOrder: {
    BACK: 'themeorder.back', // 취소
    DELETE: 'themeorder.delete', // 리뷰삭제
    CHANGEORDER: 'themeorder.changeorder', // 순서변경
    COMPLETE: 'themeorder.complete', // 완료
  },
  ticket: {
    YES: 'ticket.yes', // 매칭장소 확인, 네 이장소가 맞아요 클릭
    NO: 'ticket.no', // 매칭장소 확인, 아니오 다른 장소를 찾아볼게요 클릭
    OUT: 'ticket.out', // 매칭장소 확인, 닫기 클릭
    RECEIPTVIEW: 'ticket.receiptview', // 매칭장소 확인, 영수증보기 클릭
    EDITDATE: 'ticket.editdate', // 매칭장소 확인, 방문일 수정 클릭
    EDITTIME: 'ticket.edittime', // 매칭장소 확인, 방문시간 수정 클릭
    HISTORY: 'ticket.history', // 매칭장소 확인, 영수증 제출 이력
    SEARCHPOPUPCANCEL: 'ticket.searchpopupcancel', // 매칭장소 확인, 검색 팝업 취소
    SEARCHPOPUPYES: 'ticket.searchpopupyes', // 매칭장소 확인, 검색 팝업 인증 완료
    VIEWMORE: 'ticket.viewmore', // 매칭장소 확인, 영수증 제출 이력 더보기 클릭
    RECEIPT_NO: 'ticket.noreceipt', // [영수증]매칭장소 확인, 아니오 다른 장소를 찾아볼게요 클릭
    PAYMENT_NO: 'ticket.nopayment', // [카드내역]매칭장소 확인, 아니오 다른 장소를 찾아볼게요 클릭
  },
  visitDetail: {
    BACK: 'visitend.back', // 방문상세, 헤더>뒤로가기 클릭
    PLACE: 'visitend.place', // 방문상세, 장소명 클릭
    SAVE: 'visitend.save', // 방문상세, 장소 저장
    UNSAVE: 'visitend.unsave', // 방문상세, 장소 저장 취소
    VIEWMORE: 'visitend.viewmore', // 방문상세, 메뉴보기 클릭
    DELETE: 'visitend.delete', // 방문상세, 삭제하기 클릭
    REVIEWEND: 'visitend.reviewend', // 방문상세, 리뷰보기 클릭
    RECEIPT_PHOTO: 'visitend.receiptphoto', // 방문상세, 영수증사진 보기
    NAVER_HOTEL_DETAILS: 'visitend.naverhoteldetails', // 방문상세, 네이버 호텔 예약 보기
    ORDER_DETAILS: 'visitend.orderdetails', // 방문상세, 주문내역 보기
    RESERVATION_DETAILS: 'visitend.reservationdetails', // 방문상세, 예약내역보기
    REVIEW: 'visitend.review', // 방문상세, 리뷰쓰기 클릭
    DETAIL: 'visitend.detail', // 방문상세, 자세히보기 클릭
    FULLKEYWORD: 'visitend.fullkeyword', // 방문상세, 키워드 펼침
    POV_ADD_NOTI: 'visitend.povaddnoti', // 방문상세, 방문인증이 추가 되었어요 퉅팁
    CARD_DETAILS: 'visitend.carddetails', // 방문상세, 카드내역 상세보기
    DELETE_NO: 'visitend.deleteno', // 방문상세, 리뷰 없는 경우 삭제팝업 취소
    DELETE_YES: 'visitend.deleteyes', // 방문상세, 리뷰 없는 경우 삭제팝업 확인
    REVIEW_DELETE_NO: 'visitend.reviewdeleteno', // 방문상세, 리뷰 있는 경우 삭제팝업 취소
    REVIEW_DELETE_YES: 'visitend.reviewdeleteyes', // 방문상세, 리뷰 있는 경우 삭제팝업 확인
    PLACE_MY: 'visitend.placemy', // 방문상세,  MY플레이스 홈 클릭
    PRIVATE_GUIDEX: 'visitend.privateguidex', // 방문상세, 비공개 안내 닫기
    SURVEY: 'visitend.survey', // 방문상세, 설문조사
  },
  visit: {
    VISITENDTITLE: 'visit.visitendtitle', // 방문내역, 헤더영역 클릭
    SAVE: 'visit.save', // 방문내역, 장소 저장
    UNSAVE: 'visit.unsave', // 방문내역, 장소 저장 취소
    VIEWMORE: 'visit.viewmore', // 방문내역, 메뉴보기 클릭
    DELETE: 'visit.delete', // 방문내역, 내역삭제 클릭
    VISITENDCARD: 'visit.visitendcard', // 방문내역, 작성된 리뷰, 결제내역 클릭
    REVIEW: 'visit.review', // 방문내역, 리뷰작성버튼 클릭
    FULLKEYWORD: 'visit.fullkeyword', // 방문탭, 키워드 펼침
    MYASSET_STORENAME: 'payment.listmyassetstorename', // 결제내역>사용처제공
    DELETE_NO: 'visit.deleteno', // 방문내역, 리뷰 없는 경우 삭제팝업 취소
    DELETE_YES: 'visit.deleteyes', // 방문내역, 리뷰 없는 경우 삭제팝업 확인
    REVIEW_DELETE_NO: 'visit.reviewdeleteno', // 방문내역, 리뷰 있는 경우 삭제팝업 취소
    REVIEW_DELETE_YES: 'visit.reviewdeleteyes', // 방문내역, 리뷰 있는 경우 삭제팝업 확인
    VIEW_MORE_TOOLTIP_X: 'visit.viewmoretooltipx', // 방문탭>방문카드>더보기시 노출되는 툴팁 닫기
    REVIEW_END_CARD: 'visit.reviewendcard', // 방문카드>리뷰엔드가기
  },
  followDeletePopup: {
    DELNO: 'followerdeletepopup.delno', // 팔로워삭제팝업>삭제취소
    DELOK: 'followerdeletepopup.delok', // 팔로워삭제팝업>삭제하기
  },
  reviewerBlockPopup: {
    BLOCKNO: 'reviewerblockpopup.blockno', // 리뷰어차단안내팝업>차단취소
    BLOCKOK: 'reviewerblockpopup.blockok', // 리뷰어차단안내팝업>차단하기
    LIMITCLOSE: 'reviewerblockpopup.limitclose', // 리뷰어차단수제한팝업>확인
    UNBLOCKNO: 'reviewerblockpopup.unblockno', // 리뷰어차단해제취소
    UNBLOCKOK: 'reviewerblockpopup.unblockok', // 리뷰어차단해제하기
  },
  mission: {
    COMPLETE_MISSION: 'mission.completemission', //미션메인홈>완료한미션
    CS: 'mission.cs', //미션메인홈>고객센터도움글
    DONECARD1: 'mission.donecard1', // 영수증 리뷰 달인 1단계 > 완료보기
    DONECARD2: 'mission.donecard2', // 영수증 리뷰 달인 2단계 > 완료보기
    DONECARD3: 'mission.donecard3', // 영수증 리뷰 달인 3단계 > 완료보기
    DONECARD4: 'mission.donecard4', // 이달의 영수증 콜렉터 > 완료보기
    DONECARD5: 'mission.donecard5', // 한지역도장깨끼 > 완료보기
    DONECARD6: 'mission.donecard6', // 요즘꽂힌음식은 > 완료보기
    DONECARD7: 'mission.donecard7', // 이달의 리뷰어에도전 > 완료보기
    DONECARD8: 'mission.donecard8', // 산타가주는선물 > 완료보기
    DONECARD9: 'mission.donecard9', // 한지역도장깨기-보너스단계>완료보기
    DONECARD10: 'mission.donecard10', // 자연,지역명소 리뷰쓰기>완료보기
    DONECARD11: 'mission.donecard11', // 동영상 리뷰쓰기>완료보기
    DONEXCARD1: 'mission.donexcard1', // 영수증 리뷰 달인 1단계 > 완료닫기
    DONEXCARD2: 'mission.donexcard2', // 영수증 리뷰 달인 2단계 > 완료닫기
    DONEXCARD3: 'mission.donexcard3', // 영수증 리뷰 달인 3단계 > 완료닫기
    DONEXCARD4: 'mission.donexcard4', // 이달의 영수증 콜렉터 > 완료닫기
    DONEXCARD5: 'mission.donexcard5', // 한지역도장깨끼 > 완료닫기
    DONEXCARD6: 'mission.donexcard6', // 요즘꽂힌음식은 > 완료닫기
    DONEXCARD7: 'mission.donexcard7', // 이달의 리뷰어에도전 > 완료닫기
    DONEXCARD8: 'mission.donexcard8', // 산타가주는선물 > 완료닫기
    DONEXCARD9: 'mission.donexcard9', // 한지역도장깨기-보너스단계>완료닫기
    DONEXCARD10: 'mission.donexcard10', // 자연,지역명소 리뷰쓰기>완료닫기
    DONEXCARD11: 'mission.donexcard11', // 동영상 리뷰쓰기>완료닫기
    FLOAT_BUTTON: 'mission.floatbutton', // 미션메인홈>리뷰쓰러가기버튼
    MORECARD1: 'mission.morecard1', // 영수증리뷰달인 1단계>다음단계보기
    MORECARD2: 'mission.morecard2', // 영수증리뷰달인 2단계>다음단계보기
    MORECARD3: 'mission.morecard3', // 한지역도장깨기-보너스단계>다음단계보기
    MOREXCARD1: 'mission.morexcard1', // 영수증리뷰달인 1단계>다음단계닫기
    MOREXCARD2: 'mission.morexcard2', // 영수증리뷰달인 2단계>다음단계닫기
    MOREXCARD3: 'mission.morexcard3', // 한지역도장깨기-보너스단계>다음단계닫기
    ONBOARDING_POP_CLOSE: 'mission.onboardingpopx', //미션메인홈>온보딩팝업닫기
    SHARE: 'mission.share', //미션메인홈>공유하기
    SURVEY: 'mission.survey', //미션메인홈>설문참여하기
    TIPCARD1: 'mission.tipcard1', // 영수증 리뷰 달인 1단계 > 툴팁보기
    TIPCARD2: 'mission.tipcard2', // 영수증 리뷰 달인 2단계 > 툴팁보기
    TIPCARD3: 'mission.tipcard3', // 영수증 리뷰 달인 3단계 > 툴팁보기
    TIPCARD4: 'mission.tipcard4', // 이달의 영수증 콜렉터 > 툴팁보기
    TIPCARD5: 'mission.tipcard5', // 한지역도장깨끼 > 툴팁보기
    TIPCARD6: 'mission.tipcard6', // 요즘꽂힌음식은 > 툴팁보기
    TIPCARD7: 'mission.tipcard7', // 이달의 리뷰어에도전 > 툴팁보기
    TIPCARD8: 'mission.tipcard8', // 산타가주는선물 > 툴팁보기
    TIPCARD9: 'mission.tipcard9', // 한지역도장깨기-보너스단계>툴팁보기
    TIPCARD10: 'mission.tipcard10', // 자연,지역명소 리뷰쓰기>툴팁보기
    TIPCARD11: 'mission.tipcard11', // 동영상 리뷰쓰기>툴팁보기
    TIPXCARD1: 'mission.tipxcard1', // 영수증 리뷰 달인 1단계 > 툴팁닫기
    TIPXCARD2: 'mission.tipxcard2', // 영수증 리뷰 달인 2단계 > 툴팁닫기
    TIPXCARD3: 'mission.tipxcard3', // 영수증 리뷰 달인 3단계 > 툴팁닫기
    TIPXCARD4: 'mission.tipxcard4', // 이달의 영수증 콜렉터 > 툴팁닫기
    TIPXCARD5: 'mission.tipxcard5', // 한지역도장깨끼 > 툴팁닫기
    TIPXCARD6: 'mission.tipxcard6', // 요즘꽂힌음식은 > 툴팁닫기
    TIPXCARD7: 'mission.tipxcard7', // 이달의 리뷰어에도전 > 툴팁닫기
    TIPXCARD8: 'mission.tipxcard8', // 산타가주는선물 > 툴팁닫기
    TIPXCARD9: 'mission.tipxcard9', // 한지역도장깨기-보너스단계>툴팁닫기
    TIPXCARD10: 'mission.tipxcard10', // 자연,지역명소 리뷰쓰기>툴팁닫기
    TIPXCARD11: 'mission.tipxcard11', // 동영상 리뷰쓰기>툴팁닫기
    UNCOMPLETE_MISSION: 'mission.uncompletemission', //미션메인홈>진행중미션
    UP_CLOSE: 'mission.upclose', //미션메인홈>상단닫기버튼
    UP_SHARE: 'mission.upshare', //미션메인홈>상단공유버튼
    HISTORY: 'mission.history', //미션메인홈>지난달완료한미션보기
    GOOD_REVIEWER: 'mission.goodreviewer', //미션메인홈>우수리뷰어보기
    CHECK_RESULT: 'mission.checkresult', //미션메인홈>미션결과보기
    MYCARD: 'mission.mycard', //미션메인홈>카드연결배너
    BANNER1: 'mission.banner1', //미션메인홈>배너1(기억에남는리뷰어제보)
    REWARD_POPUPX: 'mission.rewardpopupx', // 미션메인홈>리워드안내팝업닫기
  },
  // 미션 완료 페이지
  missionHistory: {
    BACK: 'missionhistory.back', // 미션완료상세>이전화면
    TIP: 'missionhistory.tip', // 미션완료상세>지급툴팁
    MONTH: 'missionhistory.month', // 미션완료상세>월필터
    GO_MISSION: 'missionhistory.gomission', //미션완료>미션참여하기(empty화면)
    ALERT: 'missionhistory.alert', // 미션완료상세>알럿확인
    GOOD_REVIEWER: 'missionhistory.goodreviewer', // 미션완료상세>우수리뷰어보기
  },
  // 저장탭
  bmk: {
    MAP: 'bmk.map', // 이 주변 저장 장소 지도 보기
    LIST_FILTER: 'bmk.listfilter', // 리스트 필터
    WHOLE_LIST: 'bmk.wholelist', // 리스트 필터 선택> 전체 리스트
    MINE: 'bmk.mine', // 리스트 필터 선택> 내가 만든 리스트
    OTHERS: 'bmk.others', // 리스트 필터 선택> 저장한 리스트
    NEW_LIST: 'bmk.newlist', // 새 리스트 만들기
    DEFAULT_LIST: 'bmk.defaultlist', // 리스트 선택> 내 장소
    DEFAULT_LIST_MORE: 'bmk.defaultlistmore', // 내 장소 더보기(옵션)
    DEFAULT_LIST_MAP_ON: 'bmk.defaultlistmapon', // 내 장소 더보기> 지도에서 보기
    DEFAULT_LIST_MAP_OFF: 'bmk.defaultlistmapoff', // 내 장소 더보기> 지도에서 숨기기
    MY_LIST: 'bmk.mylist', // 리스트 선택> 내가 만든 리스트 선택
    MY_LIST_MORE: 'bmk.mylistmore', // 내 리스트 더보기(옵션)
    MY_LIST_EDIT: 'bmk.mylistedit', // 내 리스트 더보기> 수정
    MY_LIST_SHARE: 'bmk.mylistshare', // 내 리스트 더보기> 공유
    MY_LIST_DELETE: 'bmk.mylistdelete', // 내 리스트 더보기> 삭제
    MY_LIST_DELETE_CANCEL: 'bmk.mylistdeletecancel', // 내 리스트 삭제 팝업 취소
    MY_LIST_DELETE_OK: 'bmk.mylistdeleteok', // 내 리스트 삭제 팝업 확인
    MY_LIST_MAP_ON: 'bmk.mylistmapon', // 내 리스트 더보기> 지도에서 보기
    MY_LIST_MAP_OFF: 'bmk.mylistmapoff', // 내 리스트 더보기> 지도에서 숨기기
    OTHER_LIST: 'bmk.otherlist', // 리스트 선택> 저장한 리스트 선택
    OTHER_LIST_MORE: 'bmk.otherlistmore', // 저장한 리스트 더보기(옵션)
    OTHER_LIST_SHARE: 'bmk.otherlistshare', // 저장한 리스트 더보기> 공유
    OTHER_LIST_DELETE: 'bmk.otherlistdelete', // 저장한 리스트 더보기> 삭제
    OTHER_LIST_DELETE_CANCEL: 'bmk.otherlistdeletecancel', // 저장한 리스트 삭제 팝업 취소
    OTHER_LIST_DELETE_OK: 'bmk.otherlistdeleteok', // 저장한 리스트 삭제 팝업 확인
    DELETED_LIST: 'bmk.deletedlist', // 삭제된 저장 리스트 더보기> 삭제
    DELETED_LIST_DELETE: 'bmk.deletedlistdelete', // 삭제된 저장 리스트 더보기> 삭제
    DELETED_LIST_DELETE_CANCEL: 'bmk.deletedlistdeletecancel', // 삭제된 저장 리스트 삭제 팝업 취소
    DELETED_LIST_DELETE_OK: 'bmk.deletedlistdeleteok', // 삭제된 저장 리스트 삭제 팝업 확인
    PRIVATE_LIST: 'bmk.privatelist', // 비공개된 저장 리스트 더보기> 삭제
    PRIVATE_LIST_DELETE: 'bmk.privatelistdelete', // 비공개 리스트 더보기> 삭제
    PRIVATE_LIST_DELETE_CANCEL: 'bmk.privatelistdeletecancel', // 비공개 리스트 삭제 팝업 취소
    PRIVATE_LIST_DELETE_OK: 'bmk.privatelistdeleteok', // 비공개 리스트 삭제 팝업 확인
  },
  newlist: {
    CLOSE: 'newlist.close', // 닫기 버튼
    NAME: 'newlist.name', // 리스트 이름 입력
    COLOR: 'newlist.color', // 리스트 컬러
    PUBLIC: 'newlist.publicon', // 리스트 공개
    PRIVATE: 'newlist.publicoff', // 리스트 비공개
    MEMO: 'newlist.desc', // 리스트 메모
    URL: 'newlist.url', // 리스트 관련 URL
    DONE: 'newlist.complete', // 완료 버튼
    CLOSE_POPUP_CANCEL: 'newlist.closepopupcancel', // 닫기 팝업 취소
    CLOSE_POPUP_OK: 'newlist.closepopupok', // 닫기 팝업 확인
  },
  editlist: {
    CLOSE: 'editlist.close', // 닫기 버튼
    NAME: 'editlist.name', // 리스트 이름 입력
    COLOR: 'editlist.color', // 리스트 컬러
    PUBLIC: 'editlist.public', // 리스트 공개
    PRIVATE: 'editlist.private', // 리스트 비공개
    MEMO: 'editlist.memo', // 리스트 메모
    URL: 'editlist.url', // 리스트 관련 URL
    DONE: 'editlist.done', // 완료 버튼
    CLOSE_POPUP_CANCEL: 'editlist.closepopupcancel', // 닫기 팝업 취소
    CLOSE_POPUP_OK: 'editlist.closepopupok', // 닫기 팝업 확인
  },
  defaultlist: {
    ALL_CTG: 'defaultlist.allctg', // 필터_전체카테고리
    CLOSE: 'defaultlist.close', // 닫기(X)
    CTG: 'defaultlist.ctg', // 필터_개별카테고리선택
    DELETE_PLACE_NO: 'defaultlist.deleteplaceno', // 팝업_삭제NO
    DELETE_PLACE_YES: 'defaultlist.deleteplaceyes', // 팝업_삭제OK
    DELETE_PLACE: 'defaultlist.deleteplace', // 장소 더보기_삭제
    DESC: 'defaultlist.desc', // 장소 선택
    DISTANCE_SORT: 'defaultlist.dissort', // 위치정보>내장소 거리순 정렬
    EDIT_PLACE_LIST: 'defaultlist.editplacelist', // 편집_장소목록 편집
    EDIT_PLACE: 'defaultlist.editplace', // 장소 더보기_수정
    EDIT: 'defaultlist.edit', // 리스트 편집
    FOLDER_LIST: 'defaultlist.folderlist', // 전체리스트 보기
    HIDE: 'defaultlist.hide', // 숨기기
    LATEST_SORT: 'defaultlist.latestsort', // 정렬_최신순
    NOT_IN_SERVICE_OK: 'defaultlist.notinserviceok', // 팝업_폐업한장소조회불가확인
    NOT_IN_SERVICE: 'defaultlist.notinservice', // 폐업장소 목록 진입
    OFF_MAP: 'defaultlist.offmap', // 편집_지도에서 보기 OFF
    ON_MAP: 'defaultlist.onmap', // 편집_지도에서 보기 ON
    PLACE_URL: 'defaultlist.placeurl', // 장소관련URL
    POI_PLACE_SORT: 'defaultlist.poiplacesort', // 정렬_장소명순
    SEE_MORE: 'defaultlist.seemore', // 장소 더보기
  },
  mylist: {
    ALL_CTG: 'mylist.allctg', // 필터_전체카테고리
    CLOSE: 'mylist.close', // 닫기(X)
    CTG: 'mylist.ctg', // 필터_개별카테고리선택
    DELETE_FOLDER: 'mylist.deletefolder', // 리스트 삭제
    DELETE_PLACE_NO: 'mylist.deleteplaceno', // 팝업_삭제NO
    DELETE_PLACE_YES: 'mylist.deleteplaceyes', // 팝업_삭제OK
    DELETE_PLACE: 'mylist.deleteplace', // 장소 더보기_삭제
    DESC: 'mylist.desc', // 장소 선택
    DISTANCE_SORT: 'mylist.dissort', // 위치정보>내가만든저장리스트 거리순 정렬
    EDIT_FOLDER: 'mylist.editfolder', // 리스트 수정
    EDIT_PLACE_LIST: 'mylist.editplacelist', // 장소목록편집
    EDIT_PLACE: 'mylist.editplace', // 장소 더보기_수정
    EDIT: 'mylist.edit', // 편집
    FOLDER_LIST: 'mylist.folderlist', // 전체리스트 보기
    HIDE: 'mylist.hide', // 숨기기
    LATEST_SORT: 'mylist.latestsort', // 정렬_최신순
    NOT_IN_SERVICE_OK: 'mylist.notinserviceok', // 팝업_폐업한장소조회불가확인
    NOT_IN_SERVICE: 'mylist.notinservice', // 폐업 장소 목록 진입
    OFF_MAP: 'mylist.offmap', // 지도에서 보기 OFF
    ON_MAP: 'mylist.onmap', // 지도에서 보기 ON
    PLACE_URL: 'mylist.placeurl', // 장소관련URL
    POI_PLACE_SORT: 'mylist.poiplacesort', // 정렬_장소명순
    REMAIN_PRIVATE: 'mylist.remainprivate', // 비공개 리스트 팝업_비공개 유지
    SEE_MORE: 'mylist.seemore', // 장소 더보기
    SHARE_IN_PUBLIC: 'mylist.shareinpublic', // 비공개 리스트 팝업_공개 및 공유
    SHARE: 'mylist.share', // 리스트 공유
  },
  otherlist: {
    ALL_CTG: 'otherlist.allctg', // 필터_전체카테고리
    CLOSE: 'otherlist.close', // 닫기
    CTG: 'otherlist.ctg', // 필터_개별카테고리선택
    DESC: 'otherlist.desc', // 장소 선택
    DISTANCE_SORT: 'otherlist.dissort', // 위치정보>내가저장한타인저장리스트 거리순 정렬
    FOLDER_LIST: 'otherlist.folderlist', // 전체 리스트 보기
    HIDE: 'otherlist.hide', // 숨기기
    LATEST_SORT: 'otherlist.latestsort', // 정렬_최신순
    NOT_IN_SERVICE_OK: 'otherlist.notinserviceok', // 팝업_폐업한장소조회불가확인
    NOT_IN_SERVICE: 'otherlist.notinservice', // 폐업 장소 목록 진입
    PLACE_URL: 'otherlist.placeurl', // 장소관련URL
    POI_PLACE_SORT: 'otherlist.poiplacesort', // 정렬_장소명순
    PROFILE: 'otherlist.profile', // 작성자 프로필 보기
    REMOVE: 'otherlist.remove', // 저장 해제
    SHARE: 'otherlist.share', // 리스트 공유
    SW_DOWN: 'otherlist.swdown', // 목록 스와이프 다운_지도뷰로
    SW_UP: 'otherlist.swup', // 목록 스와이프 업_목록뷰로
  },
  sharedlist: {
    ALL_CTG: 'sharedlist.allctg', // 필터_전체카테고리
    CLOSE: 'sharedlist.close', // 닫기
    CTG: 'sharedlist.ctg', // 필터_개별카테고리선택
    DESC: 'sharedlist.desc', // 장소 선택
    DISTANCE_SORT: 'sharedlist.dissort', // 위치정보>타인공유저장리스트 거리순 정렬
    FOLDER_LIST: 'sharedlist.folderlist', // 전체리스트보기
    HIDE: 'sharedlist.hide', // 숨기기
    LATEST_SORT: 'sharedlist.latestsort', // 정렬_최신순
    NOT_IN_SERVICE_OK: 'sharedlist.notinserviceok', // 팝업_폐업한장소조회불가확인
    NOT_IN_SERVICE: 'sharedlist.notinservice', // 폐업장소 목록 진입
    PLACE_URL: 'sharedlist.placeurl', // 장소관련URL
    POI_PLACE_SORT: 'sharedlist.poiplacesort', // 정렬_장소명순
    PROFILE: 'sharedlist.profile', // 작성자 프로필 보기
    SAVE: 'sharedlist.save', // 저장 하기
    SHARE: 'sharedlist.share', // 공유
  },
  listedit: {
    SELECT: 'listedit.select', // 개별장소 선택
    DELETE: 'listedit.delete', // 삭제
    DELETE_FROM_HERE: 'listedit.deletefromhere', // 삭제확인팝업_이 리스트에서 삭제
    DELETE_FROM_ALL: 'listedit.deletefromall', // 삭제확인팝업_모든리스트에서삭제
    CANCEL_DELETE: 'listedit.canceldelete', // 삭제확인_취소
    MOVE: 'listedit.move', // 이동
    CLOSE: 'listedit.close', // 닫기(X)
  },
  movelist: {
    NEW_LIST: 'movelist.newlist', //새 리스트 만들기
    MOVE: 'movelist.move', //리스트 선택_이동
    IN_REMAIN: 'movelist.inremain', //리스트 선택_현재 리스트에도 남겨두기
    CLOSE: 'movelist.close', //닫기
  },
  editnotinservice: {
    SELECT: 'editnotinservice.select', // 개별 장소 선택
    DELETE: 'editnotinservice.delete', // 삭제
    DELETE_FROM_ALL: 'editnotinservice.deletefromall', // 삭제 완료_모든 리스트에서 삭제
    DELETE_FROM_HERE: 'editnotinservice.deletefromhere', // 삭제 완료_이 리스트에서만 삭제
    CANCEL_DELETE: 'editnotinservice.canceldelete', // 삭제확인_취소
    CLOSE: 'editnotinservice.close', // 닫기(X)
  },
  aroundbmkmap: {
    MAP: 'aroundbmk',
    LOCATION: 'aroundbmk.location',
    CLOSE: 'aroundbmk.close',
    ENLARGE: 'aroundbmk.enlarge',
    REDUCE: 'aroundbmk.reduce',
    PLACE: 'aroundbmk.place',
    PLACES: 'aroundbmk.places',
  },
  aroundbmktable: {
    ALL_CTG: 'aroundbmktable.allctg',
    ALL_MYLIST: 'aroundbmktable.allmylist',
    CTG: 'aroundbmktable.ctg',
    DELETE_PLACE_NO: 'aroundbmktable.deleteplaceno',
    DELETE_PLACE_YES: 'aroundbmktable.deleteplaceyes',
    DELETE_PLACE: 'aroundbmktable.deleteplace',
    DESC: 'aroundbmktable.desc',
    DISTANCE_SORT: 'aroundbmktable.dissort', // 위치정보>이주변 저장장소 거리순 정렬
    EDIT_PLACE: 'aroundbmktable.editplace',
    LATEST_SORT: 'aroundbmktable.latestsort',
    LIST: 'aroundbmktable',
    MAP_VIEW: 'aroundbmktable.mapview',
    MYLIST: 'aroundbmktable.mylist',
    NOT_IN_SERVICE_OK: 'aroundbmktable.notinserviceok',
    PLACE_URL: 'aroundbmktable.placeurl',
    POI_NAME_SORT: 'aroundbmktable.poinamesort',
    SEE_MORE: 'aroundbmktable.seemore',
    SW_DOWN: 'aroundbmktable.swdwn',
    SW_UP: 'aroundbmktable.swup',
  },
  placecard: {
    LISTNAME: 'placecard.listname',
    CALL: 'placecard.call',
    UNSAVE: 'placecard.unsave',
    SAVE: 'placecard.save',
    SHARE: 'placecard.share',
    DIRECTION: 'placecard.direction',
    DESC: 'placecard.desc',
    BACK: 'placecard.back',
    CLOSE: 'placecard.close',
  },
  reactfeed: {
    FILTER: 'reactfeed.filter', //반응 남긴 리뷰>리액션별 필터
    NEWEST: 'reactfeed.newest', //반응 남긴 리뷰>최신순 정렬
    OLDEST: 'reactfeed.oldest', //반응 남긴 리뷰>오래된순 정렬
    REVIEW: 'reactfeed.review', //반응 남긴 리뷰>리뷰카드
  },
  reviewfeed: {
    BACK: 'reviewfeed.back', // 뒤로가기
    PHOTO: 'reviewfeed.photo', // 사진보기
    VIDEO: 'reviewfeed.video', // 영상보기
    PICSWIPE: 'reviewfeed.picswipe', // 사진플리킹
    PLACE: 'reviewfeed.place', // 업체상세
    SAVE: 'reviewfeed.save', // 저장
    UNSAVE: 'reviewfeed.unsave', // 저장취소 또는 폴더 변경
    VIEWMORE: 'reviewfeed.viewmore', // 옵션더보기
    SHARE: 'reviewfeed.share', // 공유하기
    VIEWVISIT: 'reviewfeed.viewvisit', // 방문기록 보기
    EDIT: 'reviewfeed.edit', // 더보기 > 수정하기
    DELETE: 'reviewfeed.delete', // 더보기 > 삭제하기
    DELETENO: 'reviewfeed.deleteno', // 더보기 > 삭제하기 > 예
    DELETEYES: 'reviewfeed.deleteyes', // 더보기 > 삭제하기 > 아니오
    REACT_FIRST: 'reviewfeed.reactfirst', // 반응남기기 (0개)
    REACT: 'reviewfeed.react', // 반응남기기 (1개이상)
    HELPFUL: 'reviewfeed.helpful', // 리액션 - 도움돼요
    WANNAGO: 'reviewfeed.wannago', // 리액션 - 가고싶어요
    FUN: 'reviewfeed.fun', // 리액션 - 재밌어요
    COOL: 'reviewfeed.cool', // 리액션- 멋져요
    REACT_LIST: 'reviewfeed.reactlist', // 반응한 사람 목록
    EMOJITAB: 'reviewfeed.emojitab', // 반응한 사람목록 > 리액션별 탭
    REACT_PROFILE: 'reviewfeed.reactprofile', // 반응한 사람목록 > 프로필
    REACT_FOL: 'reviewfeed.reactfol', // 반응한 사람목록 > 팔로우
    REACT_UNFOL: 'reviewfeed.reactunfol', // 반응한 사람목록 > 팔로우해제
    MENU: 'reviewfeed.menu', // 방문스니핏
    RVSHOMORE: 'reviewfeed.rvshowmore', // 리뷰텍스트 펼치기
    KEYWORDMORE: 'reviewfeed.keywordmore', // 키워드펼치기
    WRITEMORE: 'reviewfeed.writemore', // 리뷰내용 추가유도버튼
    REPORTGUIDE: 'reviewfeed.reportguide', // 게시중단 안내 > 자세히
    HIDEGUIDE: 'reviewfeed.hideguide', // 미노출 안내 > 자세히
    PROFILE: 'reviewfeed.profile', // 유저프로필
    REVIEWCOUNT: 'reviewfeed.reviewcount', // 리뷰소비수 집계
    VISIT_KEYWORD_MORE: 'reviewfeed.visitqmore', // 방문 키워드 펼치기
  },
  otherreviewfeed: {
    BACK: 'otherreviewfeed.back', // 뒤로가기
    FOLLOW: 'otherreviewfeed.follow', // 팔로우하기
    UNFOLLOW: 'otherreviewfeed.unfollow', // 팔로우취소
    FOLREQCANCEL: 'otherreviewfeed.folreqcancel', // 팔로우신청취소
    PHOTO: 'otherreviewfeed.photo', // 사진보기
    VIDEO: 'reviewfeed.video', // 영상보기
    PICSWIPE: 'otherreviewfeed.picswipe', // 사진플리킹
    PLACE: 'otherreviewfeed.place', // 업체상세
    SAVE: 'otherreviewfeed.save', // 저장
    UNSAVE: 'otherreviewfeed.unsave', // 저장취소 또는 폴더 변경
    VIEWMORE: 'otherreviewfeed.viewmore', // 옵션더보기
    SHARE: 'otherreviewfeed.share', // 더보기 > 공유하기
    REPORT: 'otherreviewfeed.report', // 더보기 > 리뷰/리뷰어신고
    BLOCK: 'otherreviewfeed.block', // 더보기 > 리뷰어 차단
    REACT_FIRST: 'otherreviewfeed.reactfirst', // 반응남기기 (0개)
    REACT: 'otherreviewfeed.react', // 반응남기기 (1개이상)
    HELPFUL: 'otherreviewfeed.helpful', // 리액션 - 도움돼요
    WANNAGO: 'otherreviewfeed.wannago', // 리액션 - 가고싶어요
    FUN: 'otherreviewfeed.fun', // 리액션 - 재밌어요
    COOL: 'otherreviewfeed.cool', // 리액션- 멋져요
    REACT_LIST: 'otherreviewfeed.reactlist', // 반응한 사람 목록
    EMOJITAB: 'otherreviewfeed.emojitab', // 반응한 사람목록 > 리액션별 탭
    REACT_PROFILE: 'otherreviewfeed.reactprofile', // 반응한 사람목록 > 프로필
    REACT_FOL: 'otherreviewfeed.reactfol', // 반응한 사람목록 > 팔로우
    REACT_UNFOL: 'otherreviewfeed.reactunfol', // 반응한 사람목록 > 팔로우해제
    RVSHOMORE: 'otherreviewfeed.rvshowmore', // 리뷰텍스트 펼치기
    KEYWORDMORE: 'otherreviewfeed.keywordmore', // 키워드펼치기
    PROFILE: 'otherreviewfeed.profile', // 유저프로필
    REVIEWCOUNT: 'otherreviewfeed.reviewcount', // 리뷰소비수 집계
    VISIT_KEYWORD_MORE: 'otherreviewfeed.visitqmore', // 방문 키워드 펼치기
  },
  //리뷰 신고 페이지
  report: {
    CLOSE: 'report.close', // 닫기
    FULLREVIEW: 'report.fullreview', // 리뷰 펼치기
    SELECT: 'report.select', // 신고 사유 선택
    DESCRIPTION: 'report.description', // 신고 사유 설명 펼치기
    SLANDER: 'report.slander', // 명예훼손/초상권/사생활 침해 설명 펼치기
    ILLEGALPICS: 'report.illegalpics', // 불법촬영물 신고 설명 펼치기
    SUBMIT: 'report.reportsubmit', // 리뷰 신고 제출
    POPUPOK: 'report.popupok', // 리뷰 신고 제출 팝업 확인
  },
} as const
export default nClicks
